import { SvgIcon, SvgIconProps } from '@mui/material';

export function MaintenanceIllustration(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 300 264'
    >
      <path
        d='M122.475 63.624C109.496 100.588 16.0832 77.6697 33.0534 141.553C50.0237 205.436 114.699 202.231 139.574 232.307C164.449 262.382 232.777 229.422 222.695 190.2C212.613 150.977 251.169 115.438 241.399 78.661C218.144 -8.88215 139.574 14.9275 122.475 63.624Z'
        fill='#D8EFFE'
      />
      <rect
        x='92'
        y='63'
        width='111'
        height='124'
        fill='white'
      />
      <path
        d='M157.662 82.4739C156.073 82.5999 156.766 86.1145 156.703 87.5777C155.66 87.5217 154.54 87.6408 153.51 87.5777C142.105 86.8636 130.652 87.4447 119.226 87.2557C117.839 87.8718 119.03 114.329 119.065 117.55C119.107 121.107 118.455 124.789 118.742 128.395C118.791 129.011 118.595 130.201 118.742 130.628L118.266 129.032C117.874 129.046 118.357 130.978 117.944 131.265C117.09 131.867 99.6432 130.299 97.0527 130.789V67.6453C100.483 68.0024 124.427 66.6651 125.597 67.4843C126.178 67.8904 125.184 71.804 126.234 72.2661H159.083L159.405 67.4843H197.996L197.674 81.8368L157.648 82.4739H157.662Z'
        fill='#363B48'
      />
      <path
        d='M199.124 70.9906C200.524 70.4305 202.617 70.6685 202.953 72.1038L203.275 63.6533V81.3524H198.809C199.25 78.0058 199.32 74.3442 199.131 70.9906H199.124Z'
        fill='#BFC0CB'
      />
      <path
        d='M157.663 82.4813H208.212L208.445 136.203L209.246 136.07C208.966 134.782 209.605 82.4183 209.325 81.9912C209.01 81.5082 204.207 82.2083 203.906 81.3541L203.745 62.3809H91.8028L91.6417 120.582C88.6172 120.064 86.8809 124.643 85.9007 127.121C85.4387 128.29 84.5215 129.956 84.3045 131.105C84.0174 132.631 85.4037 134.045 83.9824 136.048C85.4597 135.669 85.2566 134.038 85.7397 133.814C86.4048 133.513 87.574 134.318 88.4492 134.136L85.5787 132.701L89.4084 133.023C91.2147 132.526 86.4889 131.49 86.3768 131.266L86.6989 130.629L91.6417 131.588C92.0828 130.657 91.9848 130.006 91.9638 129.039C91.9218 129.158 90.4305 130.951 90.2065 130.951C90.0945 130.951 88.7572 130.02 88.1341 130.153L90.6826 129.193C90.3885 128.899 90.0455 128.654 89.7234 128.395C89.3523 128.703 88.9043 128.941 88.6102 129.354C87.9311 128.563 89.0583 128.143 89.0863 128.08C89.1983 127.821 89.0933 127.702 89.4084 127.121C89.9334 126.162 91.3547 124.79 91.6417 124.251C91.9078 123.753 92.3139 123.305 92.6009 122.815L92.7619 63.018L203.269 63.6551V81.3541H198.802C199.243 78.0146 199.32 74.3529 199.124 70.9923C199.082 70.1802 199.46 67.2047 198.648 66.8476H96.5916L96.4306 130.79C92.916 131.329 90.2975 132.596 88.7782 135.894C88.9183 136.181 89.2123 136.006 89.4154 136.055C89.2963 134.612 92.7619 132.113 93.7211 131.91C95.8565 131.462 117.924 131.483 120.193 131.91C121.453 132.148 123.455 133.646 124.176 134.78C124.302 134.423 125.339 134.647 124.015 133.184C123.014 132.078 121.264 131.861 120.032 131.273C119.703 131.119 119.079 131.581 118.757 130.636L118.281 129.039C117.882 129.053 118.365 130.986 117.959 131.273C117.105 131.875 99.6511 130.307 97.0677 130.797V67.6528C100.498 68.0098 124.442 66.6656 125.612 67.4917C126.186 67.8978 125.192 71.8045 126.249 72.2736H159.098L159.42 67.4917H198.011L197.689 81.8442L157.663 82.4813Z'
        fill='black'
      />
      <path
        d='M158.139 67.1611V71.6279C154.694 70.9908 127.053 72.6011 126.409 71.1518C126.283 70.8718 126.381 67.6162 126.57 67.4832L158.146 67.1611H158.139Z'
        fill='#F69E23'
      />
      <path
        d='M206.776 92.6738C206.965 92.8349 207.056 92.9609 207.098 92.9959L205.824 94.2701C205.754 94.2211 205.579 94.3191 205.502 94.2701L206.776 92.6738Z'
        fill='#F4F0FB'
      />
      <path
        d='M91.9634 129.032C91.9214 129.158 90.4372 130.95 90.2062 130.943C90.0941 130.943 88.7499 130.012 88.1338 130.145L90.6822 129.186C90.3882 128.892 90.0451 128.647 89.7231 128.388C90.4512 127.8 92.0965 127.492 89.401 127.114C89.9261 126.154 91.3473 124.782 91.6344 124.243C92.3275 125.86 92.4955 127.31 91.9565 129.025L91.9634 129.032Z'
        fill='#E49F93'
      />
      <path
        d='M91.647 131.586C91.192 132.545 89.5397 133.918 88.4545 134.135L85.584 132.699L89.4136 133.021C91.22 132.531 86.5011 131.488 86.3821 131.264L86.7042 130.627L91.647 131.586Z'
        fill='#F7CBAD'
      />
      <path
        d='M89.7289 128.395C89.6589 128.338 89.7009 127.883 89.0918 128.072C89.1968 127.813 89.0918 127.694 89.4139 127.113C92.1093 127.498 90.457 127.799 89.7359 128.388L89.7289 128.395Z'
        fill='black'
      />
      <path
        d='M89.7301 128.395C89.352 128.703 88.9109 128.942 88.6169 129.355C87.9448 128.563 89.072 128.143 89.093 128.08C89.7021 127.884 89.6601 128.346 89.7301 128.402V128.395Z'
        fill='#CB8E82'
      />
      <path
        d='M120.031 131.265C119.695 131.104 119.079 131.573 118.757 130.628C118.61 130.201 118.806 129.018 118.757 128.395C122.454 129.872 149.982 127.421 150.647 128.871C150.808 129.228 150.724 130.698 150.171 130.943L120.031 131.265Z'
        fill='white'
      />
      <path
        d='M157.663 82.4736H208.212V92.3593C206.71 92.3593 203.947 92.4153 203.372 92.3593C203.372 90.681 203.372 87.3437 203.372 87.0767C197.232 87.0767 173.556 86.9824 165.959 87.2555L161.493 87.4165L161.654 157.422H202.478L202.954 119.468C204.046 124.635 205.369 132.154 208.373 136.208L208.212 161.244C191.045 161.202 173.871 161.3 156.704 161.244C157.439 136.859 155.724 111.893 156.704 87.5775C156.76 86.1143 156.074 82.6067 157.663 82.4736Z'
        fill='white'
      />
      <path
        d='M156.703 87.5781C155.723 111.893 157.439 136.867 156.703 161.245C144.745 161.21 132.787 161.273 120.822 161.245V157.737L133.417 157.1C134.272 157.079 135.364 157.394 135.966 156.624C136.967 154.363 135.042 153.466 135.007 153.277C134.755 151.919 135.343 150.232 134.685 148.811C134.825 148.776 135.511 148.328 135.959 148.335C136.365 147.494 135.672 141.536 135.959 139.884C135.987 139.723 137.632 138.386 136.918 137.014C137.002 137.014 137.912 136.384 138.514 136.692C138.409 137.126 138.668 138.435 138.99 138.603C139.417 138.82 148.12 138.792 148.561 138.603C149.072 138.379 149.205 137.196 149.037 136.846C148.624 135.991 139.992 136.419 138.514 136.37C133.711 136.202 128.972 136.104 124.162 136.047C124.232 135.669 124.057 135.06 124.162 134.773C124.288 134.416 125.324 134.64 124.001 133.177C123 132.071 121.242 131.847 120.017 131.266L150.157 130.944C150.71 130.699 150.801 129.228 150.633 128.871C149.968 127.422 122.439 129.865 118.743 128.395C118.456 124.79 119.1 121.107 119.065 117.55H153.028L153.504 87.5711C154.526 87.6341 155.646 87.5151 156.696 87.5711L156.703 87.5781Z'
        fill='#BFC0CB'
      />
      <path
        d='M122.74 121.058C126.177 121.688 149.968 120.239 151.123 121.058C151.347 121.212 151.354 123.025 151.284 123.13C150.451 124.306 125.827 122.563 122.425 123.291L122.747 121.058H122.74Z'
        fill='white'
      />
      <path
        d='M153.518 87.5783L153.042 117.557H119.079C119.044 114.337 117.854 87.8724 119.24 87.2633C130.666 87.4523 142.12 86.8712 153.525 87.5853L153.518 87.5783Z'
        fill='#DDDDDD'
      />
      <path
        d='M135.174 90.4476C150.577 89.3694 150.514 113.923 134.215 111.815C122.215 110.268 123.034 91.2948 135.174 90.4476Z'
        fill='#035ABD'
      />
      <path
        d='M140.601 93.6345C142.162 93.2074 144.004 94.7827 143.633 96.3439C143.437 97.1421 133.39 108.295 132.627 108.624C131.612 109.065 129.721 108.869 129.595 107.511C129.518 106.629 139.74 93.8725 140.601 93.6415V93.6345Z'
        fill='white'
      />
      <path
        d='M124.175 134.773C124.07 135.067 124.245 135.669 124.175 136.047C114.92 135.949 105.517 135.781 96.2683 136.047C95.6872 136.061 94.693 135.725 94.8331 136.684C94.518 136.656 89.7782 136.138 89.4141 136.047C89.2951 134.605 92.7607 132.105 93.7199 131.902C95.8552 131.454 117.923 131.475 120.191 131.902C121.452 132.14 123.461 133.639 124.175 134.773Z'
        fill='#A6A8B7'
      />
      <path
        d='M94.1962 152.633C92.3759 152.857 88.6232 152.045 88.1401 154.23C88.0841 154.195 87.209 153.333 87.181 153.27C86.5649 151.758 87.363 148.02 85.7457 147.529C83.1133 146.731 82.6582 151.142 82.7142 152.948C81.594 152.948 78.1564 153.957 77.2953 152.787C76.4971 150.715 77.3443 148.398 77.2953 146.57L94.0351 146.892C94.2872 147.067 94.2592 151.884 94.1962 152.633Z'
        fill='#F69E23'
      />
      <path
        d='M124.176 136.047C128.986 136.096 133.725 136.194 138.528 136.369V136.691C137.926 136.383 137.016 137.013 136.932 137.013C123.707 136.929 107.674 137.714 94.8337 136.691C94.6936 135.732 95.6878 136.068 96.2689 136.054C105.517 135.788 114.92 135.956 124.176 136.054V136.047Z'
        fill='#777579'
      />
      <path
        d='M94.1968 152.633C94.1408 153.305 94.4839 154.845 93.7207 155.181C93.4617 155.293 91.8514 155.181 91.3263 155.181C90.3182 155.181 89.0509 154.824 88.1338 154.222C88.6239 152.038 92.3765 152.85 94.1898 152.626L94.1968 152.633Z'
        fill='#CB730E'
      />
      <path
        d='M124.491 150.085V153.915C125.023 154.447 127.908 154.286 128.797 154.237C129.063 154.223 128.923 153.6 128.958 153.6C130.946 153.488 133.06 153.943 135.014 153.278C135.049 153.474 136.967 154.37 135.973 156.625C135.364 157.395 134.272 157.087 133.424 157.101C128.972 157.199 124.358 156.541 119.87 157.101L120.031 149.448C121.711 149.084 123.028 149.847 124.498 150.085H124.491Z'
        fill='#CB730E'
      />
      <path
        d='M134.699 148.802C135.357 150.224 134.769 151.911 135.021 153.269C133.068 153.927 130.946 153.479 128.965 153.591C128.93 152.443 129.063 150.749 128.006 150.399C127.313 150.168 125.667 150.581 124.813 150.399C124.792 150.399 124.932 150.154 124.491 150.077C123.021 149.839 121.705 149.076 120.024 149.44L120.5 148.802C124.211 148.158 131.429 149.671 134.692 148.802H134.699Z'
        fill='#F69E23'
      />
      <path
        d='M138.528 136.691V136.369C140.012 136.418 148.638 135.991 149.051 136.845C149.219 137.195 149.086 138.371 148.575 138.602C148.134 138.791 139.431 138.819 139.004 138.602C138.675 138.434 138.423 137.125 138.528 136.691Z'
        fill='white'
      />
      <path
        d='M87.1812 153.269C85.7319 153.605 84.0796 152.947 82.7144 152.947C82.6514 151.134 83.1065 146.73 85.7459 147.528C87.3632 148.018 86.5651 151.757 87.1812 153.269Z'
        fill='#150404'
      />
      <path
        d='M84.472 148.487C86.4464 147.822 87.1115 152.17 86.0683 152.632L83.3588 152.156C83.0788 151.561 83.8349 148.704 84.472 148.487Z'
        fill='#9E6927'
      />
      <path
        d='M128.958 153.592C128.958 153.592 129.063 154.215 128.797 154.229C127.908 154.278 125.023 154.439 124.491 153.907C124.484 153.466 124.82 153.606 125.128 153.585C128.335 153.431 128.867 154.425 127.999 150.393C129.056 150.743 128.916 152.43 128.958 153.585V153.592Z'
        fill='#170F04'
      />
      <path
        d='M124.814 150.399L125.136 153.592C124.828 153.606 124.484 153.473 124.498 153.914V150.084C124.933 150.154 124.793 150.399 124.821 150.406L124.814 150.399Z'
        fill='#754A13'
      />
      <path
        d='M128.005 150.4C128.873 154.426 128.341 153.439 125.135 153.593L124.812 150.4C125.66 150.582 127.305 150.169 128.005 150.4Z'
        fill='#B86309'
      />
      <path
        d='M209.324 161.398C210.682 158.332 208.295 140.619 209.324 136.047L209.359 136.04L208.4 136.194L208.239 161.23C191.072 161.188 173.891 161.286 156.731 161.23C144.773 161.195 132.808 161.258 120.849 161.23V157.723L133.445 157.086C128.992 157.184 124.378 156.526 119.89 157.086L120.051 149.433L120.527 148.796C124.238 148.152 131.456 149.664 134.719 148.796C134.859 148.761 135.545 148.313 135.993 148.32C136.399 147.48 135.706 141.522 135.993 139.87L77.47 139.233C76.3288 139.744 77.281 145.478 77.309 146.57L94.0489 146.892C94.3009 147.067 94.2729 151.884 94.2099 152.633C94.1539 153.305 94.4969 154.845 93.7338 155.181C93.4748 155.293 91.8645 155.181 91.3394 155.181C91.5494 156.239 91.0453 161.938 91.3394 162.358C91.6334 162.778 92.9567 162.267 93.2507 162.68C94.2799 164.143 92.4596 194.115 93.2507 198.4C81.3837 196.965 73.0732 209.119 79.5354 219.445C82.6089 224.36 88.0138 225.396 93.4047 225.663C119.316 226.944 146.754 224.822 172.812 225.34C184 223.331 188.201 207.977 178.868 201.102C172.294 196.257 159.342 199.513 151.445 198.554L151.284 188.192L203.744 188.031C204.794 187.289 202.876 164.689 203.905 162.358C204.416 161.188 208.806 162.561 209.324 161.398Z'
        fill='black'
      />
      <path
        d='M120.828 161.881H198.002L198.163 181.498L120.828 181.652V161.881Z'
        fill='#363B48'
      />
      <path
        d='M107.589 161.882C108.387 161.812 109.606 162.204 110.138 161.406C110.222 161.28 110.432 158.808 110.46 158.374C110.803 158.269 111.132 158.409 111.419 157.898V146.416L119.393 147.053L119.715 187.877L123.86 188.514C122.348 196.174 114.611 196.755 110.467 190.426C105.342 182.605 108.45 170.822 107.596 161.882H107.589Z'
        fill='#A6A8B7'
      />
      <path
        d='M199.278 161.881L203.269 162.042L203.108 187.393L120.669 187.232L120.83 182.611H198.641L199.278 161.881Z'
        fill='#BFC0CB'
      />
      <path
        d='M94.3571 162.519L106.952 162.68L106.791 198.561L93.874 198.4L94.3571 162.519Z'
        fill='#A6A8B7'
      />
      <path
        d='M78.0934 139.877H133.907C136.133 140.451 135.741 147.634 134.229 148.166C133.585 148.397 121.074 148.558 120.514 148.166C120.08 147.858 120.626 146.22 120.192 145.933L77.7783 146.255L78.1004 139.877H78.0934Z'
        fill='#1E2B3A'
      />
      <path
        d='M124.652 188.353C126.949 187.177 146.433 189.249 150.487 188.353L150.648 198.078L117.637 198.554L113.653 194.885C116.951 195.907 121.677 195.207 123.539 192.015C123.994 191.238 124.239 188.563 124.652 188.346V188.353Z'
        fill='#A6A8B7'
      />
      <path
        d='M110.782 153.593C108.898 152.801 106.917 153.439 105.041 153.593C104.985 147.032 98.4316 146.122 99.9368 153.915C99.3347 153.887 99.6638 153.018 99.1387 152.955C98.4106 152.871 95.9252 153.67 94.833 153.278C94.784 152.339 94.5669 147.151 95.3091 146.899L110.614 147.221C111.16 147.439 110.866 152.829 110.775 153.6L110.782 153.593Z'
        fill='#F69E23'
      />
      <path
        d='M99.615 158.374C102.128 158.542 107.463 158.703 109.823 158.374C110.026 158.346 110.306 158.423 110.46 158.374C110.439 158.808 110.229 161.279 110.138 161.405C109.599 162.203 108.387 161.818 107.589 161.881C102.64 162.301 97.1366 161.566 92.1237 161.881C91.5006 161.587 91.9277 156.945 92.1237 156.777C92.2707 156.651 95.7923 156.672 95.9534 156.777C97.2836 157.645 94.5671 158.03 99.622 158.374H99.615Z'
        fill='#5A5C6A'
      />
      <path
        d='M107.751 186.758C109.641 191.12 112.344 194.676 115.403 198.24L107.59 198.401L107.751 186.758Z'
        fill='#1E2B3A'
      />
      <path
        d='M99.9385 153.906C101.724 153.99 103.299 153.731 105.042 153.584C106.919 153.43 108.9 152.793 110.783 153.584C110.72 154.081 110.965 155.579 110.622 155.817L94.5195 155.656C95.0306 155.096 94.8766 153.983 94.8416 153.262C95.9338 153.654 98.4192 152.856 99.1473 152.94C99.6724 153.003 99.3434 153.871 99.9455 153.899L99.9385 153.906Z'
        fill='#CB730E'
      />
      <path
        d='M109.824 158.374C107.464 158.703 102.129 158.542 99.6157 158.374C99.8328 157.338 94.5959 157.982 96.9063 156.463C97.6064 156.001 108.486 156.813 110.3 156.463L109.824 158.374Z'
        fill='#1E2B3A'
      />
      <path
        d='M105.039 153.592C103.296 153.739 101.721 153.991 99.9355 153.914C98.4302 146.129 104.983 147.032 105.039 153.592Z'
        fill='#150404'
      />
      <path
        d='M101.049 148.804C103.36 149.042 104.977 151.058 103.92 153.27L100.573 153.109L101.049 148.804Z'
        fill='#9E6927'
      />
      <path
        d='M87.6569 200.15H173.765C185.954 203.679 185.282 220.776 173.128 223.751H88.294C76.0909 220.741 75.4958 203.707 87.6569 200.15Z'
        fill='#5A5C6A'
      />
      <path
        d='M89.5756 202.384H171.539C182.314 204.302 182.93 218.094 172.498 221.203H88.9385C78.7587 218.277 79.1158 204.596 89.5756 202.384Z'
        fill='black'
      />
      <path
        d='M168.984 204.295C179.304 202.909 180.536 217.856 171.854 219.284C161.177 221.042 159.77 205.534 168.984 204.295Z'
        fill='#5A5C6A'
      />
      <path
        d='M169.299 207.166C175.824 206.228 176.524 215.218 171.848 216.415C164.671 218.256 163.236 208.034 169.299 207.166Z'
        fill='black'
      />
      <path
        d='M89.8906 204.295C99.9863 203.056 101.436 217.864 92.7611 219.285C82.1543 221.028 80.719 205.422 89.8906 204.295Z'
        fill='#5A5C6A'
      />
      <path
        d='M89.8905 207.166C97.7879 205.528 97.5779 218.417 89.5685 216.414C85.5708 215.413 85.4098 208.097 89.8905 207.166Z'
        fill='black'
      />
      <path
        d='M121.466 206.529C130.078 204.841 131.135 217.066 124.659 218.326C116.034 220.013 114.85 207.824 121.466 206.529Z'
        fill='#9195A6'
      />
      <path
        d='M121.782 209.083C126.801 207.879 127.887 214.894 124.015 215.783C119.296 216.861 118.274 209.93 121.782 209.083Z'
        fill='black'
      />
      <path
        d='M137.093 206.529C147.867 204.723 145.592 222.632 135.496 217.689C130.861 215.42 131.982 207.383 137.093 206.529Z'
        fill='#9195A6'
      />
      <path
        d='M137.408 209.084C143.668 207.614 142.876 218.186 136.771 215.462C134.125 214.279 134.713 209.715 137.408 209.084Z'
        fill='#1C1C1E'
      />
      <path
        d='M105.839 206.529C114.423 204.884 115.55 217.031 109.032 218.326C100.336 220.062 99.167 207.803 105.839 206.529Z'
        fill='#9195A6'
      />
      <path
        d='M106.154 209.084C112.707 207.473 111.755 218.346 105.516 215.462C103.024 214.313 103.619 209.707 106.154 209.084Z'
        fill='black'
      />
      <path
        d='M152.72 206.529C163.432 204.611 161.786 221.54 151.761 218.011C147.07 216.359 147.322 207.495 152.72 206.529Z'
        fill='#9195A6'
      />
      <path
        d='M153.034 209.084C158.46 207.782 158.901 214.93 155.268 215.784C150.332 216.939 149.296 209.98 153.034 209.084Z'
        fill='black'
      />
      <g clipPath='url(#clip0_5471_31848)'>
        <path
          d='M40.447 102.781L40.1137 108.012C40.1137 108.012 41.2947 112.807 43.8325 112.99C47.2608 113.236 49.3428 108.434 49.3428 108.434L49.6387 101.543L40.4496 102.781H40.447Z'
          fill='#F9AB93'
        />
        <path
          d='M40.45 102.772C40.45 102.772 41.8736 107.847 46.1415 106.785C49.2259 106.016 49.5938 102.102 49.5938 102.102L40.4474 102.772H40.45Z'
          fill='black'
        />
        <path
          d='M45.8102 79.1527C56.4841 79.924 61.0799 97.0872 59.4591 100.268C55.3698 108.295 34.4485 106.027 29.3195 98.8656C27.6854 96.5863 32.2226 78.1695 45.8129 79.1501L45.8102 79.1527Z'
          fill='#714227'
        />
        <path
          d='M53.9815 88.0318C54.2347 88.7924 56.546 96.1231 52.294 101.249C51.6089 102.076 49.3083 104.848 45.7121 104.994C45.099 105.017 42.8677 105.171 40.9697 103.547C38.6664 101.575 38.3145 98.996 38.3145 98.996C38.3145 98.996 34.9689 99.4704 34.0173 96.7274C33.0149 93.8465 35.2009 91.6865 36.8643 91.6441C38.5251 91.6017 38.7037 91.9118 38.7037 91.9118L38.3838 88.8772C41.0763 85.1615 45.3736 83.4123 49.0897 84.4327C51.8008 85.1774 53.3843 87.1731 53.9841 88.0344L53.9815 88.0318Z'
          fill='#F9AB93'
        />
        <path
          d='M37.9335 96.2637C38.0215 96.2637 38.1121 96.2292 38.1788 96.1603C38.3067 96.0252 38.3041 95.8131 38.1681 95.6859L35.7369 93.3696C35.6009 93.2397 35.3877 93.245 35.2597 93.3802C35.1317 93.5153 35.1344 93.7274 35.2704 93.8546L37.7016 96.1709C37.7682 96.2345 37.8509 96.2637 37.9362 96.2637H37.9335Z'
          fill='black'
        />
        <path
          d='M35.5532 96.5341C35.6172 96.5341 35.6838 96.5155 35.7425 96.4784L37.3126 95.4342C37.4673 95.3308 37.5099 95.1214 37.4059 94.9677C37.302 94.814 37.0941 94.7716 36.9368 94.875L35.3666 95.9192C35.212 96.0225 35.1693 96.2319 35.2733 96.3856C35.3399 96.481 35.4466 96.5341 35.5559 96.5341H35.5532Z'
          fill='black'
        />
        <path
          d='M48.6179 97.8959C48.7725 97.8959 48.9138 97.7898 48.9484 97.6335C49.5189 95.0892 48.7485 92.9902 48.7165 92.9027C48.6499 92.7304 48.4579 92.643 48.282 92.7039C48.106 92.7702 48.0181 92.9637 48.082 93.1359C48.09 93.1571 48.8125 95.1422 48.2873 97.4851C48.2473 97.6653 48.362 97.8455 48.5432 97.8879C48.5672 97.8932 48.5939 97.8959 48.6179 97.8959Z'
          fill='black'
        />
        <path
          d='M51.9684 90.3483C52.0591 90.3483 52.1524 90.3112 52.219 90.2397C52.3443 90.1018 52.3363 89.8898 52.1977 89.7653C51.4992 89.1318 50.3183 89.1133 50.2703 89.1133C50.081 89.1133 49.9317 89.2617 49.9291 89.4472C49.9291 89.6327 50.0757 89.7838 50.265 89.7865C50.273 89.7865 51.2407 89.8024 51.7445 90.2635C51.8085 90.3218 51.8911 90.351 51.9711 90.351L51.9684 90.3483Z'
          fill='black'
        />
        <path
          d='M44.5923 90.666C44.6776 90.666 44.7629 90.6342 44.8269 90.5706C45.3174 90.0962 46.2824 90.0511 46.2904 90.0511C46.477 90.0432 46.621 89.8868 46.613 89.7013C46.605 89.5158 46.453 89.3753 46.2611 89.378C46.2104 89.378 45.0295 89.4336 44.3524 90.0882C44.2191 90.2181 44.2164 90.4301 44.347 90.5626C44.4137 90.6289 44.5016 90.6634 44.5896 90.6634L44.5923 90.666Z'
          fill='black'
        />
        <path
          d='M44.8694 93.8994C45.0666 93.8941 45.2133 93.7377 45.2079 93.5522L45.1599 92.1131L46.061 91.4479C46.2103 91.3366 46.2423 91.1272 46.1303 90.9761C46.0183 90.8277 45.8051 90.7986 45.6558 90.9072L44.6135 91.6785C44.5255 91.7447 44.4748 91.8481 44.4775 91.9594L44.5335 93.5761C44.5388 93.759 44.6908 93.9021 44.872 93.9021L44.8694 93.8994Z'
          fill='black'
        />
        <path
          d='M50.8196 93.8994C51.0168 93.8941 51.1635 93.7377 51.1581 93.5522L51.1101 92.1131L52.0112 91.4479C52.1605 91.3366 52.1925 91.1272 52.0805 90.9761C51.9685 90.8277 51.7553 90.7986 51.606 90.9072L50.5636 91.6785C50.4757 91.7447 50.425 91.8481 50.4277 91.9594L50.4837 93.5761C50.489 93.759 50.641 93.9021 50.8222 93.9021L50.8196 93.8994Z'
          fill='black'
        />
        <path
          d='M49.4359 100.287C49.2759 100.2 48.4762 100.891 47.3246 100.637C46.4902 100.454 46.3249 100.327 46.053 100.306C44.9173 100.215 47.3592 101.901 48.5322 101.284C49.1533 100.955 49.6598 100.409 49.4332 100.287H49.4359Z'
          fill='black'
        />
        <path
          d='M31.5832 86.3441C31.4393 86.3308 32.0018 81.8439 32.7562 80.1928C34.2624 76.9037 35.1954 74.871 37.7839 73.4266C40.1645 72.1041 42.5823 72.0325 43.614 72.014C44.7363 71.9928 48.1405 71.9742 51.2755 74.0467C53.6508 75.6184 54.6451 77.5796 55.6075 79.4745C56.8791 81.9844 57.2683 84.2238 57.3936 85.6815C49.4495 85.875 41.6253 86.2195 33.5639 86.2593C32.439 86.3812 32.351 86.4156 31.5832 86.3467V86.3441Z'
          fill='#DDDDDD'
        />
        <path
          d='M31.5829 86.3438C31.5829 86.3438 37.0478 85.9621 40.8279 86.0788C42.4114 86.1291 42.734 85.9489 44.4108 85.5619C45.9729 85.2015 47.791 85.1591 51.3605 85.0849C55.6684 84.9948 56.5402 85.1405 57.4732 85.4559C58.8914 85.9356 61.3146 86.463 61.9971 86.9958C61.7092 87.1548 59.8858 87.547 59.2939 87.6981C57.9291 88.0453 56.7828 87.7882 56.4762 87.7246C53.2612 87.0753 31.5802 86.3464 31.5802 86.3411L31.5829 86.3438Z'
          fill='#989898'
        />
        <path
          d='M49.9608 75.7422C50.5686 75.5461 48.6919 74.2156 47.9721 73.7598C47.1111 73.2165 45.7595 72.4956 43.8614 72C43.2883 72 42.5552 72.4373 42.8218 72.4956C42.9844 72.5301 43.4482 72.7262 43.6082 72.7898C44.2666 73.0495 44.3359 73.0495 44.6212 73.1953C45.1623 73.4683 46.7592 73.8685 49.225 75.9516C49.7475 75.8376 49.7129 75.8244 49.9608 75.7422Z'
          fill='#C1C6C7'
        />
        <path
          d='M45.9569 77.1229C46.5647 76.9268 44.688 75.5963 43.9682 75.1405C43.1071 74.5972 41.0598 73.6775 39.1618 73.1846C38.5886 73.1846 37.8555 73.6219 38.1221 73.6802C38.2847 73.7146 39.4417 74.1069 39.6016 74.1705C40.2601 74.4302 40.3294 74.4302 40.6146 74.576C41.1558 74.849 42.7526 75.2491 45.2185 77.3323C45.741 77.2183 45.7063 77.2051 45.9542 77.1229H45.9569Z'
          fill='#C1C6C7'
        />
        <path
          d='M52.584 84.1493C51.0325 84.2686 49.481 84.3878 47.9322 84.5071C47.8282 84.0301 47.7082 83.5398 47.5696 83.0388C47.1617 81.5441 46.6712 80.1924 46.1541 78.9892C46.0954 78.7957 46.0608 78.5572 46.1301 78.3107C46.466 77.1234 49.0385 76.376 50.3207 77.3487C50.6379 77.5898 50.8166 77.8893 50.9205 78.1093C51.2164 78.748 51.5097 79.4689 51.7682 80.2693C52.2348 81.7137 52.4694 83.0388 52.584 84.1493Z'
          fill='#C1C6C7'
        />
      </g>
      <g clipPath='url(#clip1_5471_31848)'>
        <path
          d='M248.065 84.1276C247.715 84.3189 247.326 83.9383 247.17 84.3567C247.139 84.4408 247.137 85.9716 247.17 86.1104C245.931 86.3942 244.656 86.8484 243.887 87.9397L243.662 88.0932C243.489 87.8135 243.098 87.29 242.991 87.025C242.586 86.0221 242.192 84.9854 241.797 83.9762C241.783 83.9404 241.859 83.4274 241.647 83.2129C243.775 83.5283 245.98 83.5872 248.065 84.1276Z'
          fill='#1D1D1B'
        />
        <path
          d='M243.886 87.9393C244.074 88.9759 244.259 89.9263 244.335 90.9881L243.738 91.293C243.431 90.0398 243.042 88.5911 242.843 87.3295C242.82 87.1823 242.808 87.0183 242.993 87.0246C243.1 87.2895 243.493 87.811 243.664 88.0927L243.888 87.9393H243.886Z'
          fill='#362019'
        />
        <path
          d='M244.184 93.4296C244.357 92.2353 244.427 92.3152 244.334 90.9905C244.258 89.9286 244.073 88.9782 243.886 87.9416C244.656 86.8482 245.93 86.3941 247.169 86.1123C247.307 86.6863 247.953 86.7894 248.215 87.2562C250.059 90.5468 247.387 93.2172 244.184 93.4317V93.4296Z'
          fill='#F27E64'
        />
        <path
          d='M244.333 90.9902C244.428 92.3149 244.356 92.235 244.183 93.4293C243.917 93.2821 243.845 91.743 243.734 91.2951L244.331 90.9902H244.333Z'
          fill='#C24C2A'
        />
        <path
          d='M246.05 88.2441C246.272 89.5015 246.225 89.8737 244.856 90.227C244.794 89.3123 245.303 88.6689 246.05 88.2441Z'
          fill='#22140B'
        />
        <path
          d='M231.366 76.3577C230.187 77.4301 229.39 78.8683 228.95 80.4159C227.937 83.9799 225.938 92.2875 227.694 97.2456C229.975 103.69 235.691 102.208 239.061 100.669C242.431 99.1296 243.872 96.8062 243.872 96.8062C243.872 96.8062 247.196 97.6935 249.125 94.4091C251.054 91.1269 249.449 87.649 247.538 86.972C245.628 86.2949 243.532 87.8446 243.532 87.8446L244.996 84.3079C244.996 84.3079 237.896 70.4219 231.366 76.3577Z'
          fill='#F6A587'
        />
        <path
          d='M246.39 87.8806C246.196 87.9731 245.362 88.0215 245.087 88.1014C244.043 88.4 244.311 88.6586 243.23 88.7764C241.206 85.9062 239.506 81.3224 241.632 78.4165C238.588 79.0368 231.204 78.6289 228.678 76.9005C226.755 75.5842 226.368 73.8958 229.1 73.3323C236.035 71.8982 253.601 74.9723 248.419 85.4499C248.187 85.9209 246.828 87.6725 246.39 87.8806Z'
          fill='#634E42'
        />
        <path
          d='M241.908 87.9411C241.301 88.0084 240.722 88.2292 240.092 88.1724C240.216 84.6715 240.055 85.0962 237.223 84.272C236.984 83.3721 234.37 82.0369 234.269 83.5087C233.789 83.4351 232.247 83.597 231.346 83.4898C232.748 82.1861 229.483 81.7845 229.139 83.1408C229.079 83.1218 228.528 83.29 228.54 82.7938L230.189 76.9736C232.439 78.5759 239.01 78.9649 241.719 78.3971C239.831 81.0801 240.105 85.2813 241.91 87.939L241.908 87.9411Z'
          fill='#F6A587'
        />
        <path
          d='M245.028 88.556C246.076 88.474 246.805 88.2847 247.682 89.109C249.125 90.4673 248.804 93.205 247.021 94.1386C249.335 91.3084 248.1 88.617 244.45 88.7326C244.547 88.3415 244.911 88.5665 245.026 88.5581L245.028 88.556Z'
          fill='#B5464A'
        />
        <path
          d='M244.72 89.9141C245.35 89.7269 245.813 90.2232 246 90.8266C244.722 90.1664 244.872 90.2652 244.055 91.4364C243.682 91.079 244.508 89.9772 244.72 89.9141Z'
          fill='#A1383A'
        />
        <path
          d='M230.634 90.3872C230.234 90.2337 230.323 90.219 230.405 89.7753C230.5 89.2539 231.509 86.3753 231.758 85.8265C231.828 85.6709 231.988 85.1537 232.241 85.2861L230.821 90.0171C234.08 89.5861 231.873 90.8645 230.634 90.3893V90.3872Z'
          fill='black'
        />
        <path
          d='M235.644 85.288C235.743 85.2712 235.848 85.288 235.949 85.2754C236.928 85.7422 236.554 87.6304 235.531 87.3675C234.839 87.1909 234.936 85.4142 235.644 85.288Z'
          fill='#1D1D1B'
        />
        <path
          d='M229.744 85.0361C230.829 84.6975 230.855 86.9957 229.719 86.8002C229.145 86.5374 229.24 85.1938 229.744 85.0361Z'
          fill='black'
        />
        <path
          d='M231.18 83.921C230.441 83.8327 229.692 83.7928 228.974 83.572C229.317 82.2158 232.582 82.6174 231.18 83.921Z'
          fill='black'
        />
        <path
          d='M237.058 84.7038C236.24 84.4662 234.894 84.0625 234.104 83.9405C234.204 82.4666 236.819 83.8018 237.058 84.7038Z'
          fill='black'
        />
        <path
          d='M233.812 95.3203C233.637 95.4297 233.103 95.7345 232.282 95.7892C231.302 95.8565 230.6 95.5201 230.431 95.4339'
          stroke='black'
          strokeMiterlimit='10'
          strokeLinecap='round'
        />
      </g>
      <rect
        x='161'
        y='87'
        width='42'
        height='69'
        fill='#AFACAC'
      />
      <path
        d='M242.823 100.333C239.931 102.823 236.505 104.246 232.686 105C232.35 104.154 232.296 103.682 232 102.712C235.998 102.754 240.653 101.087 243 98C242.909 98.6851 242.838 99.6483 242.821 100.333H242.823Z'
        fill='#C24C2A'
      />
      <rect
        x='167'
        y='100'
        width='33'
        height='2'
        rx='1'
        fill='black'
      />
      <path
        d='M236.105 112.968C234.343 113.527 231.374 106.478 231.17 106.622C230.204 105.268 233.691 105.725 233.093 104.276C236.732 103.583 240.001 102.28 242.758 100C242.741 100.676 242.718 101.385 242.758 102.061C242.788 102.564 244.012 104.756 244 104.844C243.927 105.358 236.935 112.373 236.105 112.968Z'
        fill='#F6A587'
      />
      <path
        d='M265.138 130.627L252.543 135.409L246.802 116.275L251.745 136.207C252.249 136.704 252.655 136.116 253.019 136.046C254.811 140.744 252.34 146.044 252.06 150.714C244.274 150.434 242.965 143.16 242.489 136.844C241.677 125.909 243.812 115.512 248.545 105.752C249.455 105.843 251.479 105.129 252.851 105.43C257.955 106.578 262.863 125.916 265.131 130.627H265.138Z'
        fill='#B86309'
      />
      <path
        d='M240.9 113.404C240.479 114.686 240.164 115.988 239.625 117.234C239.604 117.283 239.03 117.591 239.303 118.193C238.967 119.054 237.987 122.387 237.231 122.66C235.838 123.164 228.913 121.827 226.869 122.184L231.336 105.759C231.385 105.759 232.201 105.228 232.607 106.166L235.964 113.089C236.944 113.089 242.314 105.682 243.14 105.115C243.308 105.003 243.574 104.849 243.777 104.793C242.881 107.684 241.845 110.527 240.907 113.404H240.9Z'
        fill='#F69E23'
      />
      <path
        d='M227.82 106.39C225.832 107.937 224.733 111.69 223.991 114.203C222.87 118.019 221.512 124.481 221.12 128.394C220.462 129.102 219.587 129.025 218.887 129.354L213.468 120.105C218.054 115.47 221.358 108.896 227.82 106.39Z'
        fill='#B86309'
      />
      <path
        d='M265.137 130.629C265.186 131.126 263.534 132.078 263.226 132.225C261.888 132.876 254.656 135.705 253.34 136.055C253.242 136.083 253.123 136.034 253.018 136.055C252.654 136.125 252.248 136.713 251.744 136.216L246.801 116.283L252.542 135.418L265.137 130.636V130.629Z'
        fill='black'
      />
      <path
        d='M248.639 105.792C243.907 115.551 241.764 125.948 242.583 136.884C243.052 143.199 244.369 150.473 252.154 150.753C252.091 151.831 252.483 154.107 252.476 155.535C248.233 157.607 239.573 153.113 242.429 161.276C245.195 161.472 248.156 160.751 250.719 161.913C249.431 159.022 240.959 162.984 242.583 157.93C243.108 156.298 250.565 156.48 251.356 157.131C252.322 157.93 251.566 161.486 251.832 162.711C251.895 162.984 252.462 163.152 252.469 163.187C252.77 164.273 253.043 165.666 254.065 166.38C253.995 166.779 254.107 167.248 254.065 167.654C253.631 167.829 253.729 168.354 253.267 168.613L251.993 167.654C251.51 168.389 252.476 168.48 252.791 168.928L255.025 217.72C251.545 217.062 247.974 218.875 245.139 218.679C244.502 218.637 243.991 218.882 243.543 218.203C240.714 205.23 239.461 190.702 235.253 178.177C233.671 173.479 230.758 168.347 228.399 163.509C227.461 163.551 228.098 164.483 228.238 164.945C229.106 167.801 234.749 176.112 234.938 178.177C234.945 178.254 234.301 179.535 234.301 179.612C234.35 193.041 232.327 206.693 231.43 219.953C231.57 218.994 230.576 219.33 229.995 219.316C228.28 219.267 222.084 218.98 220.908 219.316C220.355 199.951 219.899 180.501 220.271 161.115C220.467 150.914 220.236 138.34 221.23 128.426C221.622 124.513 222.973 118.051 224.1 114.235C224.842 111.722 225.941 107.969 227.93 106.422C229.253 105.911 230.093 105.925 231.437 105.785L226.971 122.209C229.022 121.852 235.939 123.19 237.332 122.685C238.089 122.412 239.069 119.08 239.405 118.219C239.426 118.17 239.993 117.89 239.727 117.26C240.266 116.02 240.581 114.711 241.001 113.43L244.831 104.818C245.727 104.825 247.596 105.666 248.66 105.778L248.639 105.792Z'
        fill='#376D9D'
      />
      <path
        d='M244.808 104.833L240.979 113.444C241.917 110.567 242.953 107.724 243.849 104.833C244.087 104.77 244.507 104.833 244.808 104.833Z'
        fill='black'
      />
      <path
        d='M252.469 155.542C252.448 158.069 252.35 160.66 252.469 163.194C252.455 163.159 251.894 162.991 251.831 162.718C251.558 161.493 252.322 157.936 251.355 157.138C250.564 156.487 243.108 156.305 242.583 157.936C240.959 162.998 249.423 159.029 250.718 161.92C248.149 160.758 245.194 161.479 242.429 161.283C239.572 153.12 248.233 157.614 252.476 155.542H252.469Z'
        fill='black'
      />
      <path
        d='M235.244 178.185H234.922C234.733 176.12 229.09 167.809 228.222 164.953C228.082 164.491 227.445 163.56 228.383 163.518C230.743 168.355 233.662 173.487 235.237 178.185H235.244Z'
        fill='black'
      />
      <path
        d='M248.162 163.833C248.358 163.805 249.948 163.63 249.758 164.155L246.09 164.631C246.713 164.589 247.728 163.903 248.162 163.833Z'
        fill='#044087'
      />
      <path
        d='M239.391 118.233C239.111 117.631 239.685 117.322 239.713 117.273C239.986 117.897 239.412 118.184 239.391 118.233Z'
        fill='#866B63'
      />
      <path
        d='M225.199 126.838L238.592 127.16C238.277 133.069 239.782 139.405 231.892 139.916C222.202 140.546 224.31 133.706 225.192 126.838H225.199Z'
        fill='black'
      />
      <path
        d='M225.835 127.482H237.317C238.514 132.474 238.529 138.614 232.213 139.279C223.413 140.204 224.988 133.847 225.835 127.482Z'
        fill='#035ABD'
      />
      <path
        d='M218.895 129.353C218.741 129.423 218.391 129.598 218.258 129.675L213.154 120.427C213.154 120.427 213.378 120.203 213.476 120.104L218.895 129.353Z'
        fill='black'
      />
      <path
        d='M256.526 166.665L256.204 166.027C256.281 165.943 256.505 165.18 256.841 165.551C257.142 166.202 256.519 166.609 256.519 166.665H256.526Z'
        fill='#5E463C'
      />
      <rect
        x='167'
        y='105'
        width='33'
        height='1'
        rx='0.5'
        fill='black'
      />
      <path
        d='M37.1085 126.161C36.6815 127.421 33.881 134.009 33.916 134.45C33.986 135.199 39.1809 142.334 40.9312 142.103C40.7912 144.28 41.3443 146.023 43.4796 147.207C45.615 148.39 53.3653 148.194 46.0281 150.238C47.3373 151.743 49.8787 158.542 47.1413 153.907L47.6173 155.664C46.4061 155.944 44.8379 155.923 44.1097 158.058C43.7737 158.121 43.7037 158.422 43.4726 158.38C42.8985 157.183 43.3536 155.839 41.8763 157.106C41.4773 156.196 41.7223 155.671 41.5543 155.195C41.3653 154.628 41.5543 153.487 41.2322 152.801C41.0922 152.506 40.6231 152.689 40.5951 152.639C38.9008 149.643 37.4936 150.035 35.4912 148.495C33.4889 146.955 23.4282 140.1 23.0501 138.448C22.56 136.299 25.8086 125.895 26.5577 122.982C30.0513 122.842 34.105 124.229 37.0805 126.175L37.1085 126.161Z'
        fill='#F9AB93'
      />
      <path
        d='M85.906 127.121C85.4439 128.297 84.5267 129.964 84.3097 131.105C84.0226 132.631 85.4159 134.045 83.9876 136.048C82.5524 136.412 78.1066 135.621 77.1335 136.048C76.1603 136.475 76.9164 138.449 76.6574 139.079C76.4543 139.562 67.9409 142.65 66.9327 142.748C63.4461 143.091 62.0108 141.579 59.4414 139.555C59.4414 136.167 59.4414 132.743 59.4414 129.347V128.71C59.5954 129.48 59.6794 131.826 60.2395 131.903L64.5453 128.395C65.1754 129.663 66.8767 133.457 68.2139 133.499L85.913 127.121H85.906Z'
        fill='#F59474'
      />
      <path
        d='M39.3413 120.106C37.745 124.692 37.57 131.056 33.9223 134.458C33.8803 134.017 36.6808 127.429 37.1149 126.169C37.794 124.167 38.1861 122.003 38.7112 119.952C39.2573 119.434 39.3133 120.106 39.3483 120.113L39.3413 120.106Z'
        fill='black'
      />
      <path
        d='M40.2413 107.636C40.3113 108.196 44.4876 113.364 44.9217 113.413C47.0151 112.16 48.4083 110.073 49.5425 107.994C49.5705 108.015 49.8155 108.078 50.1796 108.316V108.638L44.9147 114.379C43.0734 113.322 40.0069 107.987 38.3756 108.001C37.8645 108.001 37.2414 108.134 36.7793 108.323C37.2764 107.28 38.9031 107.403 39.9743 107.235L40.2413 107.636Z'
        fill='black'
      />
      <path
        d='M40.6154 152.634C41.3226 156.029 36.8698 157.997 36.4707 161.406C35.7706 180.59 34.1113 199.997 32.9631 218.97L31.3668 218.494C31.3248 203.183 31.7239 187.878 32.004 172.573C32.046 170.368 31.2898 167.973 31.3668 165.558C31.5489 159.754 33.3972 153.845 35.5116 148.496C37.5069 150.036 38.9211 149.644 40.6154 152.641V152.634Z'
        fill='#035ABD'
      />
      <path
        d='M34.2383 109.897C34.3433 109.911 34.4623 109.869 34.5603 109.897C37.8089 110.807 39.9022 117.892 40.6164 120.741C40.2383 120.65 39.6642 120.139 39.3421 120.104C39.3071 120.104 39.2511 119.425 38.705 119.943C38.1869 121.995 37.7879 124.158 37.1087 126.16C34.1332 124.214 30.0725 122.835 26.5859 122.968C27.5241 119.327 28.0072 109.133 34.2383 109.89V109.897Z'
        fill='#F69E23'
      />
      <path
        d='M64.5398 128.394L60.2341 131.902C59.674 131.832 59.5899 129.48 59.4359 128.71C59.2189 127.61 59.3589 126.182 58.4768 125.202C57.9517 120.714 58.0567 116.065 56.5654 111.809C60.9342 115.638 61.8653 123.046 64.5398 128.394Z'
        fill='#B86309'
      />
      <path
        d='M61.6684 219.922C58.7909 219.425 53.848 220.041 50.8235 220.244C50.7395 219.81 49.9273 219.852 49.8643 219.446C48.8632 212.858 49.0312 204.148 48.5901 197.28C48.9892 191.406 47.659 185.469 47.953 179.581C48.4921 168.736 51.7407 166.44 57.5236 158.213C57.5867 158.122 58.9799 156.274 57.8457 156.456C59.0639 153.606 58.5878 149.56 59.442 146.248C59.834 154.11 61.3603 162.218 61.6754 170.325C62.3125 186.806 61.1993 203.427 61.6754 219.915L61.6684 219.922Z'
        fill='#1C4768'
      />
      <path
        d='M40.615 120.742C43.0164 130.277 41.4972 133.113 40.9371 142.109C39.1868 142.333 33.9919 135.199 33.9219 134.457C37.5695 131.054 37.7445 124.69 39.3408 120.104C39.6699 120.139 40.237 120.651 40.615 120.742Z'
        fill='#B86309'
      />
      <path
        d='M50.1857 108.622L54.0154 121.54C53.7983 121.869 46.6221 122.485 46.202 122.338C45.4319 122.065 40.8041 109.239 38.3887 107.985C40.02 107.971 43.0865 113.306 44.9278 114.363L50.1927 108.622H50.1857Z'
        fill='#F69E23'
      />
      <path
        d='M48.5905 197.279C48.3175 192.98 47.2813 188.444 47.3163 183.886C47.3373 180.84 47.9464 171.242 48.9126 168.735C49.9908 165.928 56.3899 159.851 57.8391 156.455C58.9733 156.273 57.5871 158.114 57.5171 158.212C51.7341 166.439 48.4925 168.735 47.9464 179.58C47.6523 185.468 48.9826 191.405 48.5835 197.279H48.5905Z'
        fill='black'
      />
      <path
        d='M38.39 107.986C40.8054 109.233 45.4332 122.066 46.2033 122.339C46.6234 122.486 53.7997 121.87 54.0167 121.541L50.187 108.624V108.302C52.3644 109.709 53.9607 109.527 56.5651 111.809C58.0634 116.066 57.9514 120.715 58.4765 125.202C58.6375 126.603 58.7075 128.087 59.4356 129.347C59.4356 132.736 59.4356 136.166 59.4356 139.555C59.4356 141.767 59.3236 144.043 59.4356 146.255C58.5815 149.567 59.0576 153.613 57.8393 156.463C56.3901 159.858 49.991 165.935 48.9128 168.743C47.9466 171.249 47.3445 180.848 47.3165 183.894L42.8498 219.292L34.2383 218.816L37.1088 161.728C37.8859 159.2 39.5942 156.967 41.5755 155.189C41.7366 155.665 41.4915 156.197 41.8976 157.1C42.1006 157.555 42.2897 158.045 42.6957 158.374C42.9548 158.409 43.2488 158.325 43.4939 158.374C43.7389 158.423 43.7949 158.115 44.131 158.052C44.502 157.982 48.6118 156.589 48.9128 155.98C49.746 154.327 47.2255 151.177 47.3165 150.876C47.5266 150.197 50.6981 150.232 49.865 148.327C49.3819 147.214 44.6561 147.081 43.4869 147.214C41.3515 146.031 40.7984 144.295 40.9384 142.11C41.5055 133.114 43.0248 130.278 40.6164 120.743C39.8953 117.893 37.8089 110.815 34.5603 109.898C35.1274 109.464 36.2056 108.54 36.7937 108.302C37.2558 108.12 37.8789 107.986 38.39 107.979V107.986Z'
        fill='#035ABD'
      />
      <path
        d='M44.1223 158.052C44.8504 155.924 46.4187 155.945 47.6299 155.658L47.1538 153.901C49.8843 158.535 47.3499 151.737 46.0406 150.232C53.3779 148.188 45.6626 148.405 43.4922 147.2C44.6614 147.067 49.3872 147.2 49.8703 148.314C50.6964 150.218 47.5249 150.183 47.3218 150.862C47.2308 151.163 49.7443 154.314 48.9181 155.966C48.6101 156.575 44.5074 157.968 44.1363 158.038L44.1223 158.052Z'
        fill='black'
      />
      <path
        d='M59.4348 128.718V129.355C58.7066 128.094 58.6436 126.61 58.4756 125.21C59.3577 126.19 59.2177 127.618 59.4348 128.718Z'
        fill='#A1B1D0'
      />
      <path
        d='M43.4879 158.375C43.2428 158.326 42.9488 158.41 42.6897 158.375C42.2837 158.046 42.0946 157.556 41.8916 157.101C43.3689 155.834 42.9138 157.178 43.4879 158.375Z'
        fill='#141627'
      />
      <path
        d='M54.8079 124.888C55.41 124.93 55.8301 124.72 56.2431 125.364C58.4975 130.79 54.3458 139.569 47.7927 136.685C45.6643 135.746 45.0622 128.962 46.0354 127.275C46.4484 126.561 53.9257 124.818 54.8079 124.881V124.888Z'
        fill='black'
      />
      <path
        d='M54.8073 125.525C56.7956 125.931 56.8167 134.486 51.9368 136.048C46.7349 137.714 45.2227 131.854 46.3569 128.234C46.6789 127.212 54.3032 125.42 54.8073 125.525Z'
        fill='#035ABD'
      />
      <rect
        x='167'
        y='111'
        width='33'
        height='1'
        rx='0.5'
        fill='black'
      />
      <path
        d='M213.198 120.771C212.901 121.017 211.08 122.137 210.908 122.485C208.899 118.712 207.395 115.208 205.701 113C204.765 114.051 203.751 115.675 203 116.418C206.485 122.027 204.957 131.279 209.601 136C212.875 134.942 215.088 131.511 218 129.784L213.198 120.771Z'
        fill='#F6A587'
      />
      <g clipPath='url(#clip2_5471_31848)'>
        <path
          d='M94.1493 116.041C94.1758 116.049 94.1972 116.076 94.2074 116.099C94.5101 116.791 94.3055 117.626 94.3098 118.321C94.3112 118.57 94.3793 118.497 94.4949 118.703C94.384 118.788 94.4894 119.065 94.4538 119.189C94.4182 119.313 93.8858 120.243 93.8223 120.248L91.3296 118.666C91.7981 118.354 92.3764 118.367 92.9039 118.239C93.3001 117.496 93.7059 116.757 94.1496 116.041L94.1493 116.041Z'
          fill='#4D6582'
        />
        <path
          d='M81.9174 137.629C82.5578 137.734 83.2095 137.496 83.5845 136.959C85.6819 132.455 87.8724 127.994 90.0754 123.538C91.0774 122.58 92.4383 122.005 93.5492 121.168C93.6604 121.142 94.0522 121.43 93.815 121.562C93.792 121.489 93.8472 121.345 93.7227 121.342C93.6489 121.409 93.5509 121.512 93.4679 121.561C92.4664 122.157 91.4496 122.744 90.5036 123.434C88.8341 126.481 87.3352 129.668 85.8096 132.805C85.1843 134.09 84.4657 136.037 83.7349 137.178C83.394 137.711 82.4638 137.982 81.9174 137.629Z'
          fill='#2D445D'
        />
        <path
          d='M88.2711 114.891C89.0326 114.122 90.187 113.8 91.2464 113.777C90.7754 114.778 90.1614 115.736 89.6179 116.709L90.0044 117.989C91.2214 118.824 92.5464 119.507 93.7528 120.358C92.481 119.629 91.2244 118.826 89.9813 118.035L89.5713 116.686L91.0606 114.031C89.8953 114.129 88.8256 114.729 87.9578 115.487C87.9273 115.151 88.6417 114.813 88.7397 114.648C88.7535 114.625 88.7524 114.572 88.7167 114.579C88.5749 114.691 88.4136 114.784 88.2709 114.891L88.2711 114.891Z'
          fill='#DDDDDD'
        />
        <path
          d='M89.7445 116.744C90.2938 115.78 90.8057 114.787 91.4073 113.858L91.6214 114.095L89.9645 116.999L90.311 118.041C90.2698 118.061 90.1512 117.968 90.1202 117.931C89.9806 117.762 89.8881 116.977 89.7449 116.744L89.7445 116.744Z'
          fill='#2D445D'
        />
        <path
          d='M94.494 118.703C94.3788 118.498 94.3107 118.57 94.3089 118.321C94.6255 117.853 94.5687 116.951 94.4201 116.423C94.3949 116.333 94.3356 116.032 94.206 116.099C94.1961 116.076 94.1747 116.048 94.148 116.041C94.2209 115.923 94.2623 115.785 94.3682 115.688C94.79 116.343 94.9158 117.227 94.7658 117.986C94.7451 118.09 94.5767 118.7 94.5337 118.738C94.5091 118.76 94.5136 118.708 94.4935 118.703L94.494 118.703Z'
          fill='#A2B0C2'
        />
        <path
          d='M94.5367 115.786C94.8208 115.886 94.8801 116.138 94.9529 116.4C95.1705 117.184 95.0683 118.221 94.8529 118.999C94.8378 118.999 94.6319 118.855 94.6272 118.842C94.6103 118.798 94.8568 118.08 94.8827 117.928C94.9998 117.237 94.889 116.397 94.5372 115.787L94.5367 115.786Z'
          fill='#2D445D'
        />
        <path
          d='M94.5578 118.981C94.6146 118.955 94.8344 119.12 94.8412 119.137C94.8771 119.227 94.2336 120.513 94.1574 120.502C94.141 120.447 93.9464 120.362 93.9432 120.323C93.9318 120.177 94.7398 119.299 94.5578 118.981Z'
          fill='#2D445D'
        />
        <path
          d='M93.6996 121.04C94.0224 120.803 94.0875 120.512 94.4754 120.879C94.3856 120.916 93.9931 121.306 93.9599 121.301C93.9418 121.298 93.6974 121.058 93.6996 121.04Z'
          fill='#2D445D'
        />
        <path
          d='M94.3087 118.321C94.3042 117.626 94.509 116.791 94.2063 116.098C94.3354 116.031 94.3951 116.333 94.4204 116.423C94.569 116.951 94.6257 117.853 94.3091 118.321L94.3087 118.321Z'
          fill='#DDDDDD'
        />
        <path
          d='M88.271 114.891C88.414 114.783 88.5752 114.69 88.7169 114.579C88.753 114.573 88.7534 114.626 88.7399 114.649C88.6421 114.812 87.9274 115.151 87.9579 115.487C88.8257 114.729 89.895 114.129 91.0607 114.031L89.5715 116.686L89.9815 118.035C91.2245 118.826 92.4811 119.629 93.753 120.358C93.8013 120.392 94.0555 120.537 94.0596 120.555C93.9125 120.701 93.7664 120.862 93.6078 120.994C92.7054 121.752 90.4458 122.721 89.9024 123.596L83.7301 136.322C83.7444 136.255 83.738 135.997 83.7306 135.917C83.7569 135.841 83.7509 135.682 83.7423 135.604C83.7665 135.658 83.7531 135.713 83.7945 135.732L84.438 134.39C84.6896 134.076 84.9826 133.367 85.1737 132.978C86.7393 129.799 88.2306 126.578 89.7987 123.399C89.9363 122.915 89.6314 122.466 89.1921 122.27C89.0886 122.224 89.1516 122.264 89.1573 122.31C88.6808 122.094 88.2504 122.336 87.9825 122.749C87.0559 124.175 86.2167 126.08 85.375 127.608C84.3595 129.451 83.3316 131.278 82.3443 133.138C82.0948 133.608 81.7936 134.078 81.5737 134.561C81.5538 134.604 81.5013 134.655 81.5908 134.642C81.4761 134.712 81.3581 134.809 81.336 134.949C81.3752 134.903 81.4139 134.872 81.4634 134.839C81.5652 134.79 81.6945 134.796 81.7876 134.769C81.6992 134.878 81.641 134.895 81.5442 135.024C81.5327 135.039 81.5529 135.124 81.5498 135.128C81.2698 135.498 80.957 135.694 81.0803 136.297C81.0698 136.409 81.0484 136.337 80.9762 136.389C80.9263 136.243 80.8607 136.1 80.8201 135.949L80.7916 135.602C81.0495 134.726 82.021 133.143 82.4896 132.27C83.559 130.277 84.7225 128.333 85.8039 126.346C86.4151 125.224 87.9262 122.79 88.0179 121.638C88.1386 120.12 87.0207 119.486 86.8865 118.118C86.7671 116.905 87.3303 115.601 88.2717 114.89L88.271 114.891Z'
          fill='#C0CCE4'
        />
        <path
          d='M87.2163 116.997C87.4041 118.045 87.8841 118.972 88.8232 119.539C88.7745 119.736 88.6356 119.891 88.545 120.065L88.4754 120.03C87.1448 119.363 86.9656 118.319 87.2159 116.997L87.2163 116.997Z'
          fill='#4D6582'
        />
        <path
          d='M87.274 116.766C87.2785 117.417 87.6388 118.373 88.1291 118.815C88.247 118.962 88.3211 119.07 88.5109 119.209C88.5775 119.258 88.8123 119.462 88.8866 119.441L89.5647 118.405L92.1099 119.941C91.9465 120.511 91.5189 121.155 91.038 121.503C91.0071 121.525 90.7974 121.579 90.7834 121.607C90.7787 121.617 90.8224 121.781 90.8237 121.816C90.7724 121.859 90.4933 121.738 90.4535 121.717C89.9769 121.46 88.8617 120.807 88.464 120.489C88.4435 120.472 88.3617 120.393 88.3655 120.367C88.4533 120.298 88.4943 120.164 88.545 120.066C88.6358 119.892 88.7745 119.738 88.8233 119.54C87.8839 118.974 87.4042 118.047 87.2164 116.998C87.2298 116.928 87.2113 116.808 87.2747 116.767L87.274 116.766Z'
          fill='#010101'
        />
        <path
          d='M92.1098 119.941L89.5647 118.405L88.8866 119.441C88.8122 119.462 88.5768 119.258 88.5108 119.209C88.6252 119.174 88.734 119.368 88.8231 119.365C88.9192 119.362 89.4535 118.332 89.5412 118.336L92.1094 119.941L92.1098 119.941Z'
          fill='#FDFEFE'
        />
        <path
          d='M88.4757 120.031L88.5453 120.066C88.4945 120.164 88.4535 120.298 88.3658 120.367C88.3619 120.392 88.4432 120.472 88.4642 120.488C88.8626 120.806 89.9771 121.459 90.4537 121.717C90.4937 121.738 90.7726 121.859 90.8239 121.815C90.8242 121.819 90.8972 121.83 90.8411 121.896C90.7098 122.023 90.1159 121.531 89.9791 121.45C89.7731 121.327 88.2861 120.512 88.2846 120.413C88.2828 120.326 88.4785 120.146 88.4759 120.031L88.4757 120.031Z'
          fill='#FDFEFE'
        />
        <path
          d='M88.1299 118.816C87.6401 118.374 87.2793 117.418 87.2748 116.767C87.2744 116.72 87.2542 116.554 87.3272 116.605C87.3157 117.399 87.6316 118.2 88.1299 118.816Z'
          fill='#FDFEFE'
        />
        <path
          d='M88.9386 120.378C88.8639 120.245 88.7703 120.194 88.6263 120.135C88.8421 119.662 89.1452 119.229 89.3971 118.77L89.8771 118.996L89.4427 119.256C89.2366 119.456 88.8567 120.09 88.9381 120.378L88.9386 120.378Z'
          fill='#C0CCE4'
        />
        <path
          d='M88.6259 120.135C88.7699 120.194 88.8636 120.245 88.9381 120.378C88.949 120.416 88.9433 120.476 88.9842 120.488C89.0301 120.471 89.0618 120.446 89.1115 120.436C89.208 120.462 89.2534 120.537 89.3198 120.598C89.3456 120.622 89.3193 120.68 89.3428 120.697C89.4088 120.741 89.4744 120.65 89.4819 120.651C89.4857 120.651 89.4875 120.692 89.5051 120.691C89.5797 120.755 89.6493 120.827 89.7247 120.888C89.755 120.912 89.8038 121.001 89.9216 120.958C89.9896 121.015 89.9997 121.117 90.049 121.166C90.1391 121.257 90.1409 121.216 90.2456 121.178C90.2788 121.235 90.3611 121.278 90.3961 121.34C90.4482 121.433 90.4552 121.459 90.3383 121.485L88.5104 120.396C88.4465 120.318 88.6087 120.174 88.6261 120.135L88.6259 120.135Z'
          fill='#2D445D'
        />
        <path
          d='M91.4961 120.357C91.5866 120.302 91.6844 120.169 91.7626 120.114C91.8531 120.051 91.9291 120.038 92.0175 119.981C92.1237 120.072 91.2132 121.439 90.9286 121.462C90.9848 121.223 90.9207 120.833 91.253 120.814C91.3859 120.806 91.4889 120.965 91.5831 120.763C91.6571 120.602 91.4663 120.646 91.4966 120.357L91.4961 120.357Z'
          fill='#C0CCE4'
        />
        <path
          d='M89.4778 118.666C89.4755 118.653 89.6145 118.478 89.6806 118.579L91.9073 119.998L89.4778 118.666Z'
          fill='#2D445D'
        />
        <path
          d='M89.958 119.094L90.2009 119.245C90.1355 119.338 89.9686 119.423 89.8941 119.511C89.6317 119.819 89.4178 120.21 89.3205 120.598C89.2543 120.536 89.2087 120.463 89.1122 120.436C89.1302 120.433 89.0907 120.395 89.1235 120.384C89.1717 120.37 89.2616 120.438 89.2914 120.425C89.3213 120.412 89.4604 119.941 89.5351 119.823C89.6619 119.625 89.9161 119.449 90.091 119.292L89.9578 119.095L89.958 119.094Z'
          fill='#DDDDDD'
        />
        <path
          d='M90.7093 119.5C90.7967 119.591 90.8629 119.712 90.9868 119.639C90.5547 120.04 90.0618 120.545 90.0484 121.166C89.9996 121.117 89.9895 121.015 89.9211 120.957C90.071 120.902 90.1643 120.406 90.2863 120.228C90.3553 120.128 90.8552 119.759 90.8362 119.679C90.8259 119.635 90.6629 119.587 90.7091 119.499L90.7093 119.5Z'
          fill='#DDDDDD'
        />
        <path
          d='M91.207 119.952C91.235 119.929 91.3029 119.926 91.3111 119.859C91.321 119.873 91.3734 119.871 91.3397 119.917C90.8882 120.256 90.5361 120.798 90.3953 121.34C90.3601 121.278 90.2782 121.235 90.2448 121.177C90.2498 121.175 90.3359 121.206 90.3549 121.189C90.387 121.161 90.5927 120.623 90.6681 120.506C90.7636 120.359 91.064 120.07 91.2068 119.951L91.207 119.952Z'
          fill='#DDDDDD'
        />
        <path
          d='M89.7252 120.888C89.6495 120.827 89.5801 120.756 89.5056 120.691C89.5587 120.687 89.6229 120.724 89.6387 120.714C89.6704 120.694 89.8781 120.145 89.9519 120.032C90.0363 119.901 90.4613 119.546 90.4731 119.511C90.5067 119.41 90.2582 119.382 90.3343 119.268C90.4357 119.357 90.4729 119.497 90.6294 119.401C90.2423 119.793 89.679 120.29 89.7254 120.888L89.7252 120.888Z'
          fill='#DDDDDD'
        />
        <path
          d='M89.6153 120.066C89.6344 119.992 89.8849 119.682 89.9457 119.725C90.0235 119.881 89.5369 120.37 89.6153 120.066Z'
          fill='#FDFEFE'
        />
        <path
          d='M89.8468 120.472C89.958 120.253 90.0415 120.011 90.2695 119.887C90.1778 120.096 90.0567 120.373 89.8468 120.472Z'
          fill='#DDDDDD'
        />
        <path
          d='M90.4425 120.611L90.3034 120.658C90.3162 120.511 90.4862 120.271 90.6392 120.247C90.7032 120.29 90.476 120.561 90.4421 120.611L90.4425 120.611Z'
          fill='#DDDDDD'
        />
        <path
          d='M90.6452 120.843C90.6744 120.714 90.7851 120.577 90.9058 120.524C90.8519 120.699 90.9394 120.743 90.807 120.924L90.7781 120.837C90.7472 120.802 90.6068 121.011 90.6452 120.843Z'
          fill='#DDDDDD'
        />
        <path
          d='M91.7623 120.114C91.684 120.169 91.5865 120.302 91.4958 120.357C91.5106 120.217 91.6113 120.095 91.4789 119.987L91.7623 120.114Z'
          fill='#2D445D'
        />
        <path
          d='M89.1763 119.846C89.247 119.689 89.3423 119.539 89.4832 119.435C89.4549 119.523 89.3709 119.672 89.315 119.742C89.296 119.766 89.2061 119.909 89.1759 119.846L89.1763 119.846Z'
          fill='#FDFEFE'
        />
        <path
          d='M89.2451 119.938C89.3237 119.79 89.4131 119.584 89.5635 119.505C89.4798 119.647 89.3944 119.857 89.2451 119.938Z'
          fill='#FDFEFE'
        />
        <path
          d='M91.3118 119.86C91.3032 119.926 91.2354 119.929 91.2078 119.952L91.0863 119.732C91.1284 119.674 91.2908 119.83 91.3118 119.86Z'
          fill='#3E5266'
        />
        <path
          d='M90.9877 119.639C90.8633 119.712 90.7976 119.591 90.7102 119.5C90.7224 119.408 90.98 119.621 90.9877 119.639Z'
          fill='#2D445D'
        />
        <path
          d='M90.201 119.245L89.9581 119.095L89.9929 119.054L90.2474 119.182C90.2672 119.245 90.2035 119.242 90.2008 119.246L90.201 119.245Z'
          fill='#4D6582'
        />
        <path
          d='M90.8184 120.958L91.0442 120.652C91.0154 120.74 90.9386 120.976 90.8184 120.958Z'
          fill='#DDDDDD'
        />
        <path
          d='M90.3036 120.657L90.444 120.61C90.4319 120.627 90.4633 120.706 90.3619 120.744C90.3769 120.617 90.2909 120.798 90.3036 120.657Z'
          fill='#62626D'
        />
        <path
          d='M90.5635 121.467C90.565 121.405 90.7048 121.436 90.7269 121.491L90.5635 121.467Z'
          fill='#C5CBCF'
        />
        <path
          d='M89.3958 119.869L89.4073 119.846C89.4265 119.799 89.4566 119.814 89.4302 119.858L89.3958 119.869Z'
          fill='#80868B'
        />
        <path
          d='M81.0793 136.297C81.2534 137.15 82.48 137.543 83.0929 136.9L83.2316 137.056L83.3069 137.051L83.6489 136.542C83.5426 136.828 83.4272 137.024 83.1739 137.201C82.2723 137.832 81.3116 137.38 80.9752 136.389C81.0474 136.337 81.0688 136.409 81.0793 136.297Z'
          fill='#C0CCE4'
        />
        <path
          d='M83.4417 135.28C83.5087 135.364 83.6113 135.519 83.6498 135.616C83.6846 135.703 83.7225 135.826 83.7308 135.917C83.7382 135.997 83.745 136.255 83.7303 136.322C83.7194 136.373 83.6705 136.484 83.6489 136.542L83.307 137.051L83.2317 137.057L83.093 136.9C83.4213 136.555 83.5365 136.024 83.3137 135.593L83.5393 135.546L83.441 135.28L83.4417 135.28Z'
          fill='#C0CCE4'
        />
        <path
          d='M80.9754 136.389C81.3118 137.38 82.2725 137.832 83.1736 137.201C82.0729 138.131 80.3865 136.977 80.7909 135.602L80.8193 135.949C80.8599 136.1 80.9256 136.243 80.9754 136.389Z'
          fill='#FDFEFE'
        />
        <path
          d='M89.7351 123.005C89.6955 122.718 89.4131 122.427 89.1571 122.31C89.1515 122.264 89.0887 122.224 89.1919 122.27C89.6313 122.467 89.9366 122.916 89.7986 123.399C88.2305 126.578 86.7396 129.799 85.1736 132.979C84.9822 133.367 84.6894 134.076 84.4378 134.39C83.9538 134.994 82.8451 134.714 82.4823 134.076C82.5316 134.053 82.5108 133.956 82.5057 133.914C82.8743 134.634 83.9807 134.915 84.4671 134.159L89.7179 123.33C89.7343 123.209 89.7524 123.13 89.7356 123.006L89.7351 123.005Z'
          fill='#FDFEFE'
        />
        <path
          d='M82.3437 133.139L82.355 133.405C82.3062 133.649 82.3619 133.865 82.4818 134.076C82.8446 134.714 83.9533 134.994 84.4373 134.39L83.7938 135.732C83.7525 135.713 83.7659 135.658 83.7417 135.605C83.6422 134.708 82.3755 134.141 81.6246 134.632C81.5995 134.645 81.5915 134.642 81.59 134.643C81.5 134.656 81.5529 134.605 81.5728 134.562C81.7932 134.08 82.0942 133.609 82.3434 133.139L82.3437 133.139Z'
          fill='#C0CCE4'
        />
        <path
          d='M89.1568 122.31C89.4129 122.426 89.6953 122.717 89.7348 123.005C89.7175 122.971 89.5389 122.861 89.5383 122.849C89.5336 122.787 89.642 122.916 89.5849 122.785C89.3244 122.19 88.504 122.191 88.1209 122.703C87.3909 123.679 86.6252 125.513 85.9999 126.648C85.0025 128.459 83.9034 130.269 82.9521 132.097C82.7644 132.459 82.4305 133.028 82.355 133.405L82.3436 133.138C83.3309 131.278 84.3588 129.452 85.3743 127.608C86.216 126.08 87.0557 124.176 87.9818 122.749C88.2498 122.336 88.6809 122.094 89.1566 122.31L89.1568 122.31Z'
          fill='#1D1D1B'
        />
        <path
          d='M81.7869 134.77C82.4924 134.568 82.9578 134.677 83.4417 135.28L83.54 135.547L83.3144 135.593C83.1762 135.325 82.9037 135.09 82.6205 134.985C82.2759 134.857 81.8826 134.975 81.5439 135.024C81.6401 134.896 81.6989 134.879 81.7874 134.77L81.7869 134.77Z'
          fill='#C0CCE4'
        />
        <path
          d='M81.5899 134.642C81.5899 134.642 81.5996 134.643 81.6245 134.63C82.528 134.178 83.3733 134.789 83.7417 135.604C83.7502 135.682 83.7562 135.84 83.7299 135.916C83.7216 135.826 83.6842 135.703 83.649 135.615C83.3964 134.712 82.2272 134.321 81.4623 134.838C81.4127 134.871 81.3738 134.903 81.3349 134.948C81.3569 134.808 81.475 134.711 81.5897 134.641L81.5899 134.642Z'
          fill='#010101'
        />
        <path
          d='M83.6491 135.616C83.6109 135.52 83.5084 135.364 83.4409 135.28C82.9571 134.677 82.4917 134.568 81.7862 134.769C81.693 134.796 81.5637 134.79 81.4619 134.839C82.2269 134.322 83.3961 134.713 83.6486 135.616L83.6491 135.616Z'
          fill='#C0CCE4'
        />
        <path
          d='M83.7422 135.604C83.3733 134.79 82.5285 134.178 81.625 134.631C82.3757 134.14 83.6431 134.707 83.7422 135.604Z'
          fill='#5385B1'
        />
        <path
          d='M89.5846 122.785C89.6419 122.915 89.5333 122.787 89.538 122.849C89.5391 122.861 89.7172 122.971 89.7345 123.005C89.7516 123.129 89.7333 123.208 89.7169 123.329L84.4661 134.158C83.9797 134.914 82.8731 134.634 82.5046 133.913C82.4478 133.467 82.4071 133.388 82.615 132.941C83.4313 131.192 84.7186 129.255 85.6743 127.527C86.4345 126.152 87.3177 124.057 88.1892 122.853C88.5988 122.287 89.0766 122.433 89.5839 122.784L89.5846 122.785Z'
          fill='#010101'
        />
        <path
          d='M89.584 122.784C89.0769 122.433 88.5989 122.287 88.1893 122.853C87.318 124.057 86.4346 126.153 85.6744 127.527C84.7189 129.255 83.4309 131.192 82.6151 132.942C82.4068 133.388 82.4474 133.467 82.5047 133.914C82.5099 133.955 82.5306 134.053 82.4813 134.076C82.361 133.864 82.3057 133.648 82.3545 133.404C82.4296 133.027 82.7635 132.458 82.9516 132.097C83.9029 130.269 85.0021 128.459 85.9995 126.648C86.6247 125.513 87.3902 123.679 88.1204 122.703C88.5036 122.191 89.324 122.189 89.5844 122.785L89.584 122.784Z'
          fill='#5C96C1'
        />
        <path
          d='M82.5341 133.449C83.5888 131.467 84.7412 129.538 85.8251 127.573C86.6047 126.16 87.3849 124.307 88.2589 123.003C88.5545 122.562 88.9203 122.549 89.3526 122.813C89.5133 122.911 89.7198 123.059 89.6588 123.27L84.3731 134.169C83.8433 134.936 82.4181 134.365 82.5334 133.45L82.5341 133.449Z'
          fill='#4D6582'
        />
        <path
          d='M81.5438 135.024C81.882 134.974 82.275 134.857 82.6204 134.985C82.9036 135.09 83.176 135.325 83.3142 135.593C83.5368 136.024 83.4218 136.555 83.0935 136.9C82.4811 137.544 81.2547 137.15 81.0799 136.297C80.9566 135.694 81.2694 135.499 81.5494 135.128C81.5525 135.124 81.5322 135.039 81.5438 135.024Z'
          fill='#DDDDDD'
        />
        <path
          d='M81.2133 135.626C81.865 134.2 84.0602 135.415 83.1801 136.727C82.4898 137.756 80.674 136.806 81.2133 135.626Z'
          fill='#010101'
        />
        <path
          d='M82.1509 136.239C82.3412 135.715 83.2813 135.297 83.2622 136.101C83.254 136.451 83.0315 136.804 82.7174 136.957C82.6816 136.975 82.4151 137.049 82.3992 137.044C82.1673 136.979 82.0737 136.452 82.1509 136.239Z'
          fill='#DDDDDD'
        />
        <path
          d='M81.271 135.8C81.4541 135.241 82.0156 134.98 82.5619 135.158C81.7019 135.175 81.1225 136.105 81.6867 136.819C81.3618 136.654 81.1582 136.142 81.2708 135.8L81.271 135.8Z'
          fill='#2D445D'
        />
      </g>
      <rect
        x='167'
        y='115'
        width='33'
        height='2'
        rx='1'
        fill='black'
      />
      <rect
        x='167'
        y='121'
        width='33'
        height='1'
        rx='0.5'
        fill='black'
      />
      <rect
        x='167'
        y='126'
        width='33'
        height='2'
        rx='1'
        fill='black'
      />
      <rect
        x='167'
        y='132'
        width='33'
        height='1'
        rx='0.5'
        fill='black'
      />
      <path
        d='M263.334 132.007C264.33 141.628 263.707 151.132 264 160.746C263.019 162.186 264.388 163.674 263.663 165.587C262.33 169.112 260.988 168.165 260.776 168.241C260.637 168.296 260.332 168.489 259.519 168.853C259.27 168.963 258.821 169.114 257.489 168.865C256.252 167.788 256.442 167.096 256.325 165.738C256.325 165.683 256.969 165.285 256.662 164.648C256.31 164.284 256.076 165.032 255.995 165.114C255.798 165.313 255.629 166.163 254.831 166.677C254.655 166.787 253.937 166.575 253.666 166.677C253.71 166.273 253.593 165.813 253.666 165.429C254.025 163.53 256.398 160.561 256.669 159.025C257.321 155.294 254.758 142.608 254.003 138.096C253.901 137.479 253.71 135.977 253 135.751C254.377 135.415 261.942 132.638 263.341 132L263.334 132.007Z'
        fill='#F6A587'
      />
      <rect
        x='167'
        y='138'
        width='33'
        height='1'
        rx='0.5'
        fill='black'
      />
      <rect
        x='167'
        y='142'
        width='33'
        height='1'
        rx='0.5'
        fill='black'
      />
      <path
        d='M165.076 152.999C164.938 152.999 164.984 153.016 165.246 152.89C166.286 152.389 167.32 151.875 168.318 151.315C169.13 150.861 170.326 150.241 170.588 149.357C170.641 149.181 170.643 148.99 170.368 149C169.708 149.024 169.008 149.501 168.6 149.899C168.017 150.469 167.331 151.78 167.96 152.502C168.555 153.184 169.727 152.315 170.116 151.902C170.251 151.758 171.242 150.515 170.762 150.345C170.48 150.245 170.112 150.593 170.001 150.761C169.793 151.075 169.693 151.526 169.74 151.885C169.838 152.646 171.023 152.364 171.472 152.024C171.959 151.655 172.369 151.078 172.547 150.548C172.637 150.283 172.763 149.749 172.333 149.644C171.193 149.367 171.02 151.055 171.284 151.632C171.438 151.966 171.807 152.19 172.236 152.167C172.949 152.13 173.508 151.622 173.834 151.127C173.989 150.891 174.272 150.363 173.94 150.137C173.476 149.822 173.088 150.322 172.976 150.647C172.821 151.099 172.787 151.776 173.255 152.113C173.579 152.346 174.158 152.404 174.527 152.212C174.74 152.1 175.112 151.77 174.967 151.528C174.847 151.327 174.48 151.249 174.26 151.197C173.412 150.994 172.51 150.918 171.634 150.872C170.34 150.804 168.996 150.829 167.778 151.241C167.74 151.254 167.007 151.524 167.073 151.595C167.184 151.715 167.654 151.739 167.81 151.779C168.509 151.955 169.2 152.153 169.898 152.331C170.487 152.48 171.068 152.628 171.619 152.861C171.711 152.899 171.851 152.925 171.895 152.999'
        stroke='black'
        strokeWidth='1.43485'
        strokeLinecap='round'
      />
      <path
        d='M192.328 150.512C191.5 150.165 190.74 149.731 189.948 149.335C189.782 149.252 188.645 148.685 189.112 149.243C189.556 149.774 193.246 151.845 192.63 152.58C192.285 152.993 190.996 152.97 190.467 152.988C190.187 152.998 188.92 153.08 189.371 152.621C190.453 151.52 192.863 151.448 193.813 150.26C194.036 149.98 191.769 149.429 191.578 150.616C191.352 152.017 194.106 151.603 194.837 150.92C195.139 150.638 195.53 150.126 195.414 149.731C195.301 149.35 195.181 150.245 195.183 150.306C195.212 151.093 196.067 151.546 197 151.546'
        stroke='black'
        strokeWidth='1.43485'
        strokeLinecap='round'
      />
      <path
        d='M37.1939 161.768C37.9781 159.241 39.6794 157.007 41.6607 155.229C41.4647 154.662 41.6537 153.514 41.3386 152.835C41.2056 152.541 40.7295 152.723 40.7015 152.674C41.4087 156.069 36.9559 158.037 36.5568 161.446C35.8567 180.629 34.2044 200.037 33.0492 219.01C32.9932 219.906 33.9664 226.046 33.2102 226.347H70.8417C69.5255 221.713 66.851 222.224 63.1894 221.243C62.4543 221.047 61.8522 219.983 61.7542 219.969C58.8767 219.472 53.9338 220.088 50.9093 220.291C51.1683 221.643 51.6584 223.757 51.0703 225.073C49.6071 220.284 44.6082 222.644 42.9349 219.332L34.3234 218.856L37.1939 161.768Z'
        fill='black'
      />
      <path
        d='M215.627 222.203C213.505 223.295 211.615 223.722 210.845 226.347H231.568C231.309 226.165 231.351 220.774 231.407 219.969C231.547 219.01 230.553 219.346 229.972 219.332C228.257 219.283 222.061 218.996 220.885 219.332C220.674 219.395 218.147 221.923 217.538 222.203C217.454 222.245 216.012 222 215.627 222.203Z'
        fill='black'
      />
      <path
        d='M245.123 218.695L245.284 226.347H262.185C261.975 224.478 261.912 222.616 260.749 221.082C260.14 220.277 255.765 217.876 255.008 217.736C251.529 217.078 247.958 218.898 245.123 218.695Z'
        fill='black'
      />
      <path
        d='M255.178 220.285C256.186 219.97 256.691 221.286 255.815 221.559C254.807 221.874 254.303 220.558 255.178 220.285Z'
        fill='white'
      />
      <path
        d='M258.685 221.242C260.029 220.801 259.742 222.474 259.007 222.516C258.16 222.565 257.95 221.487 258.685 221.242Z'
        fill='white'
      />
      <g clipPath='url(#clip3_5471_31848)'>
        <path
          d='M275.176 168.419C275.181 168.448 275.165 168.481 275.147 168.501C274.597 169.111 273.644 169.311 272.94 169.642C272.688 169.76 272.797 169.79 272.646 169.995C272.503 169.931 272.275 170.16 272.131 170.185C271.987 170.21 270.771 170.148 270.733 170.09L271.072 167.007C271.628 167.3 271.909 167.849 272.307 168.284C273.265 168.306 274.223 168.339 275.176 168.42L275.176 168.419Z'
          fill='#4D6582'
        />
        <path
          d='M247.006 167.088C247.225 167.739 247.8 168.238 248.536 168.338C254.182 168.189 259.832 168.147 265.482 168.12C266.967 168.61 268.244 169.617 269.66 170.266C269.743 170.359 269.65 170.862 269.395 170.701C269.457 170.645 269.632 170.629 269.572 170.511C269.466 170.473 269.311 170.43 269.219 170.375C268.104 169.715 266.989 169.037 265.806 168.473C261.859 168.339 257.857 168.43 253.891 168.473C252.266 168.491 249.921 168.732 248.39 168.582C247.675 168.512 246.925 167.767 247.006 167.088Z'
          fill='#2D445D'
        />
        <path
          d='M273.352 162.36C274.521 162.714 275.436 163.646 276 164.629C274.742 164.658 273.455 164.532 272.189 164.48L271.086 165.444C270.856 166.979 270.837 168.544 270.586 170.077C270.679 168.54 270.855 166.983 271.027 165.444L272.189 164.425L275.646 164.575C274.953 163.527 273.799 162.805 272.586 162.347C272.913 162.16 273.62 162.671 273.837 162.686C273.867 162.688 273.921 162.662 273.896 162.632C273.71 162.552 273.534 162.444 273.351 162.36H273.352Z'
          fill='#DDDDDD'
        />
        <path
          d='M272.219 164.615C273.478 164.678 274.749 164.691 276 164.819L275.867 165.132L272.072 164.942L271.189 165.757C271.148 165.728 271.182 165.573 271.204 165.526C271.304 165.316 272.056 164.859 272.219 164.616V164.615Z'
          fill='#2D445D'
        />
        <path
          d='M272.646 169.995C272.796 169.79 272.688 169.76 272.94 169.641C273.577 169.718 274.465 169.241 274.926 168.853C275.004 168.787 275.281 168.59 275.147 168.5C275.165 168.48 275.182 168.447 275.176 168.418C275.332 168.431 275.494 168.405 275.647 168.459C275.196 169.163 274.361 169.696 273.514 169.912C273.397 169.942 272.692 170.071 272.631 170.048C272.596 170.036 272.651 170.015 272.646 169.994V169.995Z'
          fill='#A2B0C2'
        />
        <path
          d='M275.632 168.663C275.676 168.977 275.45 169.151 275.22 169.342C274.535 169.915 273.428 170.307 272.529 170.47C272.52 170.456 272.562 170.195 272.573 170.185C272.609 170.148 273.464 170.042 273.632 169.995C274.394 169.78 275.191 169.281 275.632 168.664V168.663Z'
          fill='#2D445D'
        />
        <path
          d='M272.396 170.185C272.451 170.226 272.395 170.51 272.381 170.524C272.308 170.6 270.674 170.601 270.646 170.524C270.693 170.483 270.681 170.26 270.719 170.239C270.861 170.16 272.165 170.505 272.396 170.185Z'
          fill='#2D445D'
        />
        <path
          d='M269.866 170.349C270.271 170.54 270.6 170.464 270.425 171.001C270.342 170.934 269.746 170.749 269.734 170.715C269.727 170.697 269.846 170.355 269.866 170.349Z'
          fill='#2D445D'
        />
        <path
          d='M272.94 169.641C273.644 169.31 274.597 169.11 275.147 168.5C275.281 168.59 275.005 168.788 274.927 168.853C274.465 169.241 273.578 169.719 272.94 169.642V169.641Z'
          fill='#DDDDDD'
        />
        <path
          d='M273.353 162.36C273.536 162.443 273.712 162.551 273.897 162.632C273.922 162.663 273.868 162.688 273.838 162.686C273.622 162.671 272.914 162.159 272.588 162.346C273.8 162.804 274.954 163.526 275.647 164.574L272.191 164.425L271.029 165.444C270.857 166.983 270.68 168.54 270.587 170.076C270.577 170.138 270.559 170.445 270.543 170.457C270.32 170.387 270.082 170.326 269.867 170.239C268.637 169.748 266.502 168.083 265.336 167.984L249.258 168.174C249.333 168.156 249.592 168.029 249.67 167.984C249.761 167.973 249.919 167.893 249.993 167.848C249.951 167.896 249.889 167.909 249.89 167.957L251.582 167.93C252.029 168.019 252.9 167.96 253.391 167.957C257.421 167.932 261.454 167.817 265.484 167.794C266.045 167.696 266.346 167.199 266.322 166.694C266.316 166.575 266.308 166.653 266.263 166.68C266.24 166.131 265.775 165.841 265.219 165.784C263.297 165.585 260.934 165.692 258.953 165.621C256.562 165.534 254.182 165.428 251.789 165.376C251.184 165.363 250.553 165.301 249.95 165.322C249.896 165.324 249.817 165.298 249.876 165.376C249.747 165.301 249.588 165.236 249.435 165.281C249.501 165.297 249.552 165.318 249.611 165.349C249.712 165.422 249.772 165.546 249.847 165.621C249.691 165.589 249.645 165.542 249.464 165.512C249.443 165.508 249.367 165.567 249.361 165.566C248.842 165.478 248.484 165.276 247.934 165.675C247.815 165.718 247.877 165.664 247.787 165.621C247.911 165.505 248.023 165.376 248.155 165.267L248.493 165.077C249.515 164.908 251.619 165.075 252.745 165.104C255.315 165.171 257.884 165.349 260.453 165.43C261.905 165.476 265.148 165.75 266.367 165.294C267.971 164.694 268.046 163.347 269.368 162.578C270.54 161.895 272.152 161.811 273.354 162.36H273.353Z'
          fill='#C0CCE4'
        />
        <path
          d='M270.675 162.36C269.705 163.029 269.008 163.915 268.91 165.063C268.684 165.111 268.456 165.053 268.233 165.05V164.968C268.233 163.405 269.203 162.746 270.675 162.359V162.36Z'
          fill='#4D6582'
        />
        <path
          d='M270.94 162.306C270.28 162.616 269.492 163.404 269.292 164.072C269.204 164.251 269.132 164.372 269.087 164.615C269.071 164.701 268.983 165.017 269.042 165.077L270.44 165.227L270.175 168.338C269.513 168.453 268.641 168.354 268.042 168.066C268.003 168.048 267.842 167.876 267.806 167.876C267.794 167.876 267.649 167.995 267.615 168.012C267.544 167.984 267.525 167.665 267.526 167.618C267.545 167.05 267.641 165.696 267.762 165.173C267.768 165.146 267.807 165.032 267.836 165.024C267.951 165.073 268.107 165.049 268.233 165.051C268.456 165.054 268.683 165.112 268.909 165.064C269.006 163.916 269.704 163.03 270.675 162.361C270.753 162.34 270.866 162.266 270.939 162.307L270.94 162.306Z'
          fill='#010101'
        />
        <path
          d='M270.175 168.337L270.44 165.226L269.043 165.076C268.984 165.016 269.071 164.699 269.087 164.614C269.181 164.705 269.039 164.899 269.087 164.981C269.139 165.07 270.459 165.087 270.499 165.171L270.175 168.336V168.337Z'
          fill='#FDFEFE'
        />
        <path
          d='M268.233 164.968V165.05C268.108 165.048 267.951 165.072 267.836 165.023C267.808 165.031 267.769 165.145 267.763 165.172C267.643 165.696 267.546 167.049 267.527 167.617C267.525 167.665 267.545 167.983 267.616 168.011C267.612 168.013 267.637 168.087 267.542 168.065C267.347 168.002 267.544 167.213 267.557 167.046C267.576 166.795 267.648 165.016 267.748 164.968C267.836 164.925 268.118 165.025 268.234 164.968H268.233Z'
          fill='#FDFEFE'
        />
        <path
          d='M269.293 164.072C269.493 163.404 270.281 162.616 270.941 162.305C270.988 162.283 271.146 162.186 271.132 162.278C270.318 162.641 269.665 163.314 269.293 164.072Z'
          fill='#FDFEFE'
        />
        <path
          d='M268.115 165.566C268.212 165.433 268.217 165.321 268.204 165.158C268.794 165.139 269.389 165.219 269.984 165.24L269.998 165.797L269.513 165.511C269.204 165.412 268.366 165.354 268.115 165.565V165.566Z'
          fill='#C0CCE4'
        />
        <path
          d='M268.204 165.158C268.217 165.321 268.213 165.433 268.115 165.566C268.082 165.594 268.018 165.617 268.027 165.661C268.067 165.696 268.109 165.714 268.144 165.756C268.167 165.859 268.115 165.936 268.086 166.027C268.074 166.063 268.002 166.066 267.997 166.095C267.986 166.178 268.112 166.197 268.115 166.204C268.117 166.208 268.076 166.229 268.086 166.245C268.058 166.345 268.022 166.444 267.997 166.544C267.988 166.584 267.923 166.671 268.027 166.761C268.003 166.852 267.905 166.909 267.88 166.979C267.833 167.106 267.876 167.089 267.968 167.169C267.927 167.227 267.925 167.324 267.88 167.387C267.812 167.479 267.789 167.498 267.703 167.4L267.88 165.172C267.926 165.076 268.155 165.16 268.203 165.159L268.204 165.158Z'
          fill='#2D445D'
        />
        <path
          d='M269.439 167.956C269.542 168.015 269.727 168.044 269.822 168.092C269.932 168.147 269.984 168.212 270.087 168.269C270.049 168.411 268.196 168.199 268.027 167.943C268.299 167.883 268.662 167.64 268.851 167.943C268.927 168.064 268.818 168.235 269.072 168.228C269.272 168.223 269.131 168.064 269.439 167.957V167.956Z'
          fill='#C0CCE4'
        />
        <path
          d='M270.131 165.266C270.142 165.259 270.39 165.307 270.322 165.416L270.013 168.174L270.131 165.266Z'
          fill='#2D445D'
        />
        <path
          d='M269.939 165.919L269.91 166.218C269.782 166.2 269.611 166.084 269.484 166.055C269.036 165.954 268.53 165.937 268.086 166.028C268.115 165.937 268.167 165.859 268.145 165.756C268.157 165.772 268.176 165.716 268.203 165.742C268.243 165.781 268.219 165.897 268.247 165.919C268.276 165.941 268.826 165.85 268.983 165.865C269.25 165.89 269.558 166.047 269.807 166.137L269.939 165.919H269.939Z'
          fill='#DDDDDD'
        />
        <path
          d='M269.91 166.816C269.862 166.941 269.773 167.059 269.91 167.142C269.282 166.925 268.518 166.699 267.88 166.979C267.905 166.91 268.003 166.853 268.027 166.761C268.16 166.876 268.711 166.73 268.954 166.761C269.091 166.779 269.721 167.074 269.792 167.019C269.832 166.989 269.798 166.813 269.91 166.815L269.91 166.816Z'
          fill='#DDDDDD'
        />
        <path
          d='M269.704 167.495C269.742 167.51 269.779 167.573 269.851 167.549C269.842 167.565 269.871 167.613 269.807 167.603C269.232 167.339 268.502 167.263 267.88 167.386C267.925 167.323 267.927 167.226 267.968 167.168C267.973 167.172 267.986 167.267 268.013 167.277C268.057 167.294 268.709 167.234 268.866 167.25C269.065 167.27 269.511 167.416 269.705 167.494L269.704 167.495Z'
          fill='#DDDDDD'
        />
        <path
          d='M267.997 166.544C268.021 166.444 268.058 166.345 268.086 166.245C268.117 166.293 268.111 166.371 268.13 166.381C268.167 166.401 268.83 166.338 268.983 166.354C269.159 166.372 269.736 166.604 269.777 166.599C269.897 166.583 269.8 166.336 269.954 166.354C269.915 166.491 269.792 166.592 269.969 166.694C269.374 166.514 268.582 166.219 267.998 166.544H267.997Z'
          fill='#DDDDDD'
        />
        <path
          d='M268.777 166.055C268.862 166.038 269.304 166.128 269.292 166.204C269.173 166.351 268.428 166.124 268.777 166.055Z'
          fill='#FDFEFE'
        />
        <path
          d='M268.483 166.462C268.762 166.464 269.051 166.428 269.293 166.584C269.033 166.597 268.69 166.613 268.483 166.462Z'
          fill='#DDDDDD'
        />
        <path
          d='M268.644 167.088L268.526 166.979C268.682 166.922 269.012 166.969 269.115 167.101C269.104 167.181 268.712 167.096 268.644 167.087V167.088Z'
          fill='#DDDDDD'
        />
        <path
          d='M268.512 167.386C268.658 167.353 268.854 167.392 268.969 167.481C268.764 167.512 268.763 167.615 268.512 167.576L268.586 167.508C268.606 167.462 268.322 167.429 268.512 167.386Z'
          fill='#DDDDDD'
        />
        <path
          d='M269.821 168.092C269.726 168.045 269.541 168.016 269.438 167.957C269.588 167.905 269.764 167.942 269.806 167.767L269.821 168.092Z'
          fill='#2D445D'
        />
        <path
          d='M268.778 165.539C268.973 165.531 269.174 165.55 269.351 165.634C269.247 165.648 269.053 165.639 268.954 165.62C268.92 165.613 268.728 165.596 268.778 165.538V165.539Z'
          fill='#FDFEFE'
        />
        <path
          d='M268.718 165.647C268.909 165.651 269.164 165.638 269.321 165.742C269.133 165.731 268.876 165.749 268.718 165.647Z'
          fill='#FDFEFE'
        />
        <path
          d='M269.85 167.549C269.778 167.572 269.741 167.51 269.703 167.495L269.865 167.277C269.946 167.29 269.869 167.516 269.85 167.549Z'
          fill='#3E5266'
        />
        <path
          d='M269.91 167.142C269.773 167.06 269.862 166.941 269.91 166.817C270.01 166.785 269.925 167.126 269.91 167.142Z'
          fill='#2D445D'
        />
        <path
          d='M269.91 166.218L269.939 165.919L269.998 165.933V166.232C269.944 166.28 269.914 166.219 269.909 166.218H269.91Z'
          fill='#4D6582'
        />
        <path
          d='M268.483 167.604L268.91 167.671C268.806 167.686 268.526 167.725 268.483 167.604Z'
          fill='#DDDDDD'
        />
        <path
          d='M268.527 166.979L268.645 167.087C268.622 167.084 268.558 167.15 268.469 167.074C268.604 167.028 268.379 167.033 268.527 166.979Z'
          fill='#62626D'
        />
        <path
          d='M267.836 167.604C267.899 167.576 267.939 167.721 267.895 167.767L267.836 167.604Z'
          fill='#C5CBCF'
        />
        <path
          d='M268.865 165.756H268.895C268.953 165.752 268.953 165.788 268.895 165.783L268.865 165.756Z'
          fill='#80868B'
        />
        <path
          d='M247.933 165.675C247.155 166.24 247.379 167.576 248.345 167.849L248.257 168.053L248.301 168.121L248.992 168.203C248.647 168.238 248.39 168.221 248.08 168.067C246.98 167.517 246.95 166.403 247.786 165.621C247.876 165.664 247.814 165.718 247.933 165.675Z'
          fill='#C0CCE4'
        />
        <path
          d='M250.169 167.414C250.118 167.516 250.012 167.685 249.933 167.767C249.862 167.841 249.756 167.934 249.668 167.985C249.591 168.029 249.332 168.157 249.256 168.175C249.199 168.188 249.061 168.195 248.991 168.202L248.3 168.12L248.256 168.052L248.344 167.848C248.862 167.994 249.461 167.853 249.786 167.441L249.948 167.631L250.168 167.413L250.169 167.414Z'
          fill='#C0CCE4'
        />
        <path
          d='M247.786 165.621C246.95 166.402 246.98 167.516 248.08 168.066C246.574 167.47 246.889 165.344 248.492 165.077L248.154 165.267C248.022 165.376 247.909 165.505 247.786 165.621Z'
          fill='#FDFEFE'
        />
        <path
          d='M265.85 167.549C266.123 167.377 266.274 166.975 266.262 166.68C266.306 166.653 266.316 166.575 266.321 166.694C266.345 167.199 266.044 167.697 265.482 167.794C261.453 167.817 257.419 167.932 253.39 167.957C252.898 167.96 252.028 168.019 251.581 167.93C250.721 167.76 250.441 166.587 250.905 165.947C250.953 165.982 251.042 165.917 251.081 165.893C250.537 166.577 250.815 167.748 251.831 167.849L265.512 167.686C265.643 167.644 265.732 167.624 265.85 167.55V167.549Z'
          fill='#FDFEFE'
        />
        <path
          d='M251.787 165.376L251.522 165.511C251.249 165.58 251.057 165.734 250.904 165.946C250.44 166.587 250.72 167.759 251.58 167.929L249.888 167.956C249.887 167.909 249.949 167.895 249.991 167.848C250.853 167.332 250.784 165.877 249.903 165.403C249.877 165.385 249.875 165.377 249.873 165.376C249.815 165.297 249.893 165.323 249.947 165.321C250.55 165.301 251.181 165.363 251.786 165.376H251.787Z'
          fill='#C0CCE4'
        />
        <path
          d='M266.263 166.68C266.275 166.975 266.123 167.377 265.851 167.549C265.876 167.517 265.897 167.298 265.909 167.291C265.97 167.258 265.894 167.42 265.998 167.305C266.47 166.781 266.051 166.011 265.336 165.892C263.973 165.666 261.718 165.81 260.246 165.757C257.897 165.672 255.498 165.491 253.155 165.458C252.693 165.451 251.944 165.406 251.522 165.512L251.787 165.376C254.181 165.428 256.561 165.534 258.951 165.621C260.933 165.692 263.296 165.585 265.218 165.784C265.774 165.841 266.24 166.132 266.262 166.68H266.263Z'
          fill='#1D1D1B'
        />
        <path
          d='M249.846 165.621C250.41 166.188 250.536 166.677 250.169 167.414L249.949 167.632L249.786 167.442C249.989 167.186 250.089 166.82 250.051 166.505C250.006 166.121 249.686 165.807 249.463 165.513C249.643 165.542 249.69 165.59 249.846 165.621V165.621Z'
          fill='#C0CCE4'
        />
        <path
          d='M249.875 165.376C249.875 165.376 249.879 165.386 249.905 165.403C250.825 166.038 250.633 167.119 249.993 167.848C249.918 167.893 249.76 167.973 249.67 167.984C249.758 167.934 249.863 167.841 249.935 167.766C250.724 167.105 250.526 165.823 249.611 165.348C249.552 165.318 249.5 165.296 249.435 165.28C249.588 165.235 249.747 165.301 249.876 165.375L249.875 165.376Z'
          fill='#010101'
        />
        <path
          d='M249.934 167.767C250.013 167.686 250.118 167.517 250.17 167.414C250.536 166.676 250.41 166.188 249.846 165.62C249.771 165.546 249.711 165.421 249.61 165.349C250.525 165.824 250.724 167.105 249.934 167.767V167.767Z'
          fill='#C0CCE4'
        />
        <path
          d='M249.993 167.848C250.633 167.119 250.824 166.039 249.904 165.403C250.785 165.877 250.854 167.334 249.993 167.848Z'
          fill='#5385B1'
        />
        <path
          d='M265.997 167.305C265.894 167.42 265.969 167.258 265.909 167.291C265.897 167.298 265.876 167.517 265.85 167.549C265.733 167.623 265.643 167.644 265.512 167.685L251.831 167.848C250.815 167.747 250.536 166.576 251.081 165.892C251.506 165.628 251.566 165.553 252.125 165.538C254.319 165.482 256.943 165.78 259.187 165.864C260.971 165.932 263.55 165.776 265.218 166.027C266.002 166.145 266.096 166.663 265.998 167.304L265.997 167.305Z'
          fill='#010101'
        />
        <path
          d='M265.997 167.305C266.096 166.664 266.001 166.146 265.218 166.028C263.55 165.776 260.97 165.932 259.186 165.865C256.943 165.781 254.319 165.482 252.125 165.539C251.565 165.553 251.505 165.629 251.081 165.893C251.041 165.917 250.953 165.982 250.904 165.947C251.058 165.734 251.249 165.581 251.522 165.512C251.943 165.405 252.692 165.451 253.155 165.458C255.497 165.491 257.897 165.672 260.245 165.757C261.718 165.81 263.972 165.666 265.335 165.893C266.051 166.012 266.47 166.781 265.997 167.305V167.305Z'
          fill='#5C96C1'
        />
        <path
          d='M251.566 165.702C254.119 165.76 256.666 165.934 259.216 166.028C261.049 166.095 263.329 165.956 265.1 166.163C265.699 166.233 265.897 166.571 265.85 167.101C265.832 167.298 265.786 167.561 265.541 167.603L251.772 167.766C250.722 167.63 250.577 166.023 251.566 165.701L251.566 165.702Z'
          fill='#4D6582'
        />
        <path
          d='M249.463 165.512C249.686 165.806 250.006 166.119 250.052 166.503C250.089 166.819 249.989 167.185 249.787 167.441C249.462 167.853 248.863 167.994 248.346 167.848C247.379 167.576 247.155 166.24 247.933 165.674C248.483 165.275 248.841 165.477 249.36 165.566C249.366 165.567 249.442 165.508 249.463 165.512Z'
          fill='#DDDDDD'
        />
        <path
          d='M248.684 165.484C250.465 165.425 250.348 168.057 248.566 167.848C247.168 167.684 247.209 165.533 248.684 165.484Z'
          fill='#010101'
        />
        <path
          d='M248.537 166.652C249.167 166.584 250.071 167.27 249.243 167.63C248.884 167.787 248.411 167.744 248.096 167.521C248.06 167.496 247.849 167.281 247.846 167.264C247.794 167.015 248.281 166.68 248.537 166.652Z'
          fill='#DDDDDD'
        />
        <path
          d='M248.537 165.62C249.198 165.529 249.749 165.934 249.846 166.53C249.391 165.731 248.151 165.624 247.713 166.489C247.715 166.107 248.131 165.675 248.536 165.62H248.537Z'
          fill='#2D445D'
        />
      </g>
      <path
        d='M26.624 226.312L209.207 226.312'
        stroke='#0B2777'
        strokeWidth='6.30718'
        strokeLinecap='round'
      />
      <path
        d='M215.129 226.312H268.097'
        stroke='#0B2777'
        strokeWidth='6.30718'
        strokeLinecap='round'
      />
      <path
        d='M200.442 114.909C200.618 115.068 201.285 115.617 202.448 115.629C203.642 115.643 205.135 115.088 205.473 114.378C205.987 113.29 203.697 112.399 201.662 109.699C201.202 109.089 200.908 108.862 199.469 106.68C199.358 106.515 198.542 104.764 196.763 103.011C196.379 102.634 195.502 102.825 195.227 102.918C195.043 102.978 195.196 102.783 195.463 105.11C195.671 106.91 196.221 109.636 197.803 113.344'
        fill='#F6A587'
      />
      <path
        d='M191.899 98.1028L200.424 113.321C200.787 113.965 201.41 114.31 201.931 114.154L212.061 111.144C212.856 110.907 213.029 109.678 212.393 108.771L201.477 93.2376C201.074 92.6655 200.468 92.4149 199.988 92.6214L192.248 95.9461C191.588 96.2305 191.422 97.2496 191.896 98.1028H191.899Z'
        fill='#575756'
      />
      <path
        d='M192.607 97.9442L201.125 112.77C201.474 113.376 202.121 113.403 202.574 113.257L211.536 110.515C212.223 110.292 212.027 109.31 211.424 108.46L201.081 93.8441C200.702 93.3058 200.157 93.0722 199.744 93.2652L192.746 96.3089C192.177 96.5764 192.146 97.1451 192.607 97.9475V97.9442Z'
        fill='white'
      />
      <path
        d='M201.176 96.982L195.756 99.3249C195.403 99.4772 194.977 99.3554 194.797 99.054C194.621 98.7527 194.764 98.3837 195.112 98.2347L200.533 95.8918C200.885 95.7395 201.311 95.8614 201.491 96.1627C201.667 96.464 201.525 96.8331 201.176 96.982Z'
        fill='#4760F6'
      />
      <path
        d='M202.52 98.9527L197.099 101.296C196.747 101.448 196.321 101.326 196.141 101.025C195.965 100.723 196.107 100.354 196.456 100.205L201.876 97.8625C202.229 97.7102 202.655 97.8321 202.835 98.1334C203.011 98.4347 202.868 98.8038 202.52 98.9527Z'
        fill='#4760F6'
      />
      <path
        d='M203.445 100.923L198.025 103.266C197.673 103.419 197.246 103.297 197.067 102.995C196.891 102.694 197.033 102.325 197.382 102.176L202.802 99.8333C203.154 99.6809 203.581 99.8028 203.76 100.104C203.936 100.405 203.794 100.774 203.445 100.923Z'
        fill='#4760F6'
      />
      <path
        d='M204.792 102.89L199.372 105.233C199.02 105.385 198.593 105.264 198.414 104.962C198.238 104.661 198.38 104.292 198.728 104.143L204.149 101.8C204.501 101.648 204.928 101.77 205.107 102.071C205.283 102.372 205.141 102.741 204.792 102.89Z'
        fill='#4760F6'
      />
      <path
        d='M206.135 104.861L200.715 107.204C200.362 107.356 199.936 107.234 199.756 106.933C199.58 106.632 199.723 106.263 200.071 106.114L205.492 103.771C205.844 103.618 206.27 103.74 206.45 104.042C206.626 104.343 206.484 104.712 206.135 104.861Z'
        fill='#4760F6'
      />
      <path
        d='M207.483 106.832L202.062 109.174C201.71 109.327 201.283 109.205 201.104 108.904C200.928 108.602 201.07 108.233 201.419 108.084L206.839 105.741C207.191 105.589 207.618 105.711 207.797 106.012C207.974 106.314 207.831 106.683 207.483 106.832Z'
        fill='#4760F6'
      />
      <path
        d='M231 104.263C231 105.138 232.253 106.153 232.781 106.848C233.094 107.259 233.525 107.905 233.675 108.381C233.857 108.96 233.953 109.576 234.226 110.129C234.341 110.362 234.497 110.63 234.558 110.879C234.628 111.167 234.994 111.792 235.216 111.993C235.358 112.123 237.152 110.311 237.377 110.046C237.905 109.423 238.496 108.861 239.041 108.255C239.559 107.679 240.03 106.992 240.726 106.585C241.469 106.15 241.996 105.468 242.77 105.032C243.023 104.889 244 104.314 244 104'
        stroke='black'
        strokeWidth='0.5'
        strokeLinecap='round'
      />
      <defs>
        <clipPath id='clip0_5471_31848'>
          <rect
            width='33'
            height='41'
            fill='white'
            transform='matrix(-1 0 0 1 62 72)'
          />
        </clipPath>
        <clipPath id='clip1_5471_31848'>
          <rect
            width='23'
            height='29'
            fill='white'
            transform='matrix(-1 0 0 1 250 73)'
          />
        </clipPath>
        <clipPath id='clip2_5471_31848'>
          <rect
            width='25.5094'
            height='8.57256'
            fill='white'
            transform='translate(77.582 135.463) rotate(-63.3931)'
          />
        </clipPath>
        <clipPath id='clip3_5471_31848'>
          <rect
            width='29'
            height='9'
            fill='white'
            transform='translate(247 162)'
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}
